@if (!isNew && !hideForm && isLoaded) {
  <div>
    <form id="generalData" [formGroup]="form" class="form" (change)="onFormChange()" (ngSubmit)="onSubmit()" autocomplete="new-password">
      @if (readOnly4Info === false) {
        <div>
          @if (mailMode !== 'edit') {
            <div class="form-group mt-4">
              <p-fileUpload
                multiple="false"
                showUploadButton="false"
                showCancelButton="false"
                styleClass="fileUploadCustom"
                #pMailUpload
                class="d-block"
                name="myfile[]"
                (onSelect)="dragAttachement($event)">
              </p-fileUpload>
            </div>
          }
          @if (mailMode !== 'edit') {
            <div class="d-flex justify-content-end">
              <i-button [text]="'joinAFile' | translate" styleClass="green" (click)="onUploadClick()"></i-button>
            </div>
          }
          <div class="row mt-3">
            <div class="col-md-6 mb-2">
              <label class="containerc mb-0">
                {{ 'annexesNonScannees' | translate }}
                <input
                  type="checkbox"
                  formControlName="annexeNonScannee"
                  class="super-compos-input-text form-control"
                  id="annexeNonScannee"
                  data-test="annexeNonScannee-checkbox" />
                <span class="checkmark chek-menu"></span>
              </label>
            </div>
            @if (form.value.annexeNonScannee) {
              <div class="col-md-6">
                <label class="containerc mb-0">
                  {{ 'annexeDiffusee' | translate }}
                  <input
                    type="checkbox"
                    formControlName="annexeDiffusee"
                    class="super-compos-input-text form-control"
                    id="annexeDiffusee"
                    data-test="annexeDiffusee-checkbox" />
                  <span class="checkmark chek-menu"></span>
                </label>
              </div>
            }
            @if (form.value.annexeNonScannee) {
              <div class="col-md-12 mb-2">
                <h4 class="custom-h4-title noPaddingLeft">{{ 'nombreAnnexesNonScannees' | translate }}</h4>
                <i-input
                  [type]="'number'"
                  [iInput]="{ placeholder: 'nombreAnnexesNonScannees' | translate }"
                  [control]="form.get('annexeNonScanneeNombre')"
                  styleClass="d-block w-100">
                </i-input>
              </div>
            }
          </div>
          <div class="d-flex justify-content-between mt-4">
            <div class="justify-content-start">
              <h4 class="custom-h4-title">{{ 'type' | translate }}</h4>
              <label class="containerr d-inline-flex justify-content-start" *ngIf="!selectedUserService?.refuserCreationEntrant"
                >{{ 'entrant' | translate }}
                <input
                  type="radio"
                  [checked]="true"
                  value="E"
                  formControlName="typeEntrantSortant"
                  id="typeEntrantSortant"
                  data-test="type-checkbox"
                  (click)="typeChange('E')" />
                <span class="checkmarkr"></span>
              </label>
              <label class="containerr d-inline-block" *ngIf="!selectedUserService?.refuserCreationSortant"
                >{{ 'sortant' | translate }}
                <input
                  type="radio"
                  value="S"
                  (click)="typeChange('S')"
                  formControlName="typeEntrantSortant"
                  id="typeEntrantSortant"
                  data-test="type-checkbox" />
                <span class="checkmarkr"></span>
              </label>
              <label class="containerr d-inline-block"
                >{{ 'interne' | translate }}
                <input
                  type="radio"
                  value="I"
                  formControlName="typeEntrantSortant"
                  id="typeEntrantSortant"
                  data-test="type-checkbox"
                  (click)="typeChange('I')" />
                <span class="checkmarkr"></span>
              </label>
              @if (selectedUserService?.refuserCreationSortant === true) {
                <p class="input-error">{{ 'selectedServiceNotOutgoing' | translate }}</p>
              }
              @if (selectedUserService?.refuserCreationEntrant === true) {
                <p class="input-error">{{ 'selectedServiceNotIncoming' | translate }}</p>
              }
            </div>
            @if (rightSelectedServices === null || rightSelectedServices?.interdireConfidentiels === false) {
              <div>
                <h4 class="custom-h4-title">{{ 'privacy' | translate }}</h4>
                <label class="containerc mb-0">
                  {{ 'mailPrivate' | translate }}
                  <input type="checkbox" formControlName="confidentiel" name="confidentiel" class="super-compos-input-text form-control" />
                  <span class="checkmark chek-menu"></span>
                </label>
              </div>
            }
          </div>
          <div class="row">
            <div class="form-group col-12 p-fluid mb-2">
              <h4 class="custom-h4-title">{{ 'service' | translate }} *</h4>
              <p-treeSelect
                [options]="showAllServices ? serviceParent : servicesOnlyParent"
                #treeSelect
                selectionMode="single"
                (onShow)="onShowTreeSelect()"
                [placeholder]="'pleaseSelectAService' | translate"
                appendTo="body"
                (onNodeSelect)="select($event); onServiceSelect($event.node.value)"
                (onNodeUnselect)="unselect()"
                [emptyMessage]="'noResultFound' | translate"
                [filter]="true"
                [filterPlaceholder]="'global.filterPlaceholder' | translate"
                [filterBy]="'label'"
                [filterMode]="'strict'"
                [metaKeySelection]="false"></p-treeSelect>
              @if (!selectedOption) {
                <div class="input-error">{{ 'serviceRequired' | translate }}</div>
              }
            </div>
          </div>
          @if (numerisations_center.length > 0 && typeEntrantSortant !== 'S') {
            <div class="row">
              <div class="form-group col-12 mb-2 p-fluid">
                <h4 class="custom-h4-title">{{ 'centerNum' | translate }}</h4>
                <p-dropdown
                  [showClear]="true"
                  [options]="numerisations_center"
                  formControlName="CentreNumerisationId"
                  [placeholder]="'pleaseSelectACenterNum' | translate"
                  appendTo="body"
                  [filter]="true"
                  styleClass="w-100 dropdown-inforius"
                  [emptyFilterMessage]="'noResultFound' | translate">
                </p-dropdown>
              </div>
            </div>
          }
          @if (checkMatrice?.refExpediteur?.invisible === false) {
            <div class="row">
              <div class="form-group col-12 mb-2">
                <h4 class="custom-h4-title">{{ 'senderReference' | translate }} {{ checkMatrice?.refExpediteur?.obligatoire ? '*' : '' }}</h4>
                <input
                  formControlName="refExpediteur"
                  name="refExpediteur"
                  id="refExpediteur"
                  type="text"
                  autocomplete="new-password"
                  class="super-compos-input-text form-control w-100"
                  [readonly]="checkMatrice?.refExpediteur?.lectureSeule" />
                @if (checkMatrice?.refExpediteur?.warning === true && checkMatrice?.refExpediteur?.obligatoire === false) {
                  <div class="input-warning">{{ 'recommendedToAddSenderRef' | translate }}</div>
                }
                @if (checkMatrice?.refExpediteur?.obligatoire === true) {
                  <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                }
              </div>
            </div>
          }
          <div class="d-flex justify-content-between row">
            <div class="form-group col-3 mb-2 p-fluid">
              @if (typeEntrantSortant !== 'S') {
                <h4 class="custom-h4-title" id="titleDateEntree">
                  {{ 'entryDate' | translate }}
                  @if (!configuration?.mails?.hideConfirmNoDateEntree) {
                    <span> *</span>
                  }
                </h4>
              }
              @if (typeEntrantSortant === 'S') {
                <h4 class="custom-h4-title" id="titleDateSortie">
                  {{ 'exitDate' | translate }}
                  @if (!configuration?.mails?.hideConfirmNoDateEntree) {
                    <span> *</span>
                  }
                </h4>
              }
              @if (locale4Calendar) {
                <p-calendar
                  [firstDayOfWeek]="1"
                  appendTo="body"
                  [locale]="locale4Calendar"
                  formControlName="dateEntree"
                  [showIcon]="true"
                  [iconDisplay]="'input'"
                  dateFormat="dd/mm/yy"
                  [disabled]="configuration?.mails?.dateEntreeBloquee">
                </p-calendar>
              }
            </div>
            @if (checkMatrice?.dateDocument?.invisible === false) {
              <div class="form-group col-3 p-fluid">
                <h4 class="custom-h4-title" id="titleDateDocument">
                  {{ 'documentDate' | translate }}
                  {{ checkMatrice?.dateDocument?.obligatoire || !configuration?.mails?.hideConfirmNoDateDoc ? '*' : '' }}
                </h4>
                @if (locale4Calendar) {
                  <p-calendar
                    [firstDayOfWeek]="1"
                    appendTo="body"
                    [locale]="locale4Calendar"
                    formControlName="dateDocument"
                    [showIcon]="true"
                    [iconDisplay]="'input'"
                    dateFormat="dd/mm/yy"
                    [disabled]="checkMatrice?.dateDocument?.lectureSeule">
                  </p-calendar>
                }
                @if (checkMatrice?.dateDocument?.warning === true && checkMatrice?.dateDocument?.obligatoire === false) {
                  <div class="input-warning">{{ 'recommendedToAddDocumentDate' | translate }}</div>
                }
                @if (checkMatrice?.dateDocument?.obligatoire === true) {
                  <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                }
              </div>
            }
            @if (checkMatrice?.dateEcheance?.invisible === false) {
              <div class="form-group col-3 p-fluid">
                <h4 class="custom-h4-title" id="titleDateEcheance">
                  {{ 'dueDate' | translate }} {{ checkMatrice?.dateEcheance?.obligatoire ? '*' : '' }}
                </h4>
                @if (locale4Calendar) {
                  <p-calendar
                    [firstDayOfWeek]="1"
                    appendTo="body"
                    [locale]="locale4Calendar"
                    formControlName="dateEcheance"
                    [showIcon]="true"
                    [iconDisplay]="'input'"
                    dateFormat="dd/mm/yy"
                    (onClose)="checkEcheanceDate()"
                    [disabled]="checkMatrice?.dateEcheance?.lectureSeule">
                  </p-calendar>
                }
                @if (checkMatrice?.dateEcheance?.warning === true && checkMatrice?.dateEcheance?.obligatoire === false) {
                  <div class="input-warning">{{ 'recommendedToAddDueDate' | translate }}</div>
                }
                @if (checkMatrice?.dateEcheance?.obligatoire === true) {
                  <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                }
              </div>
            }
            <div class="form-group col-3 p-fluid">
              <h4 class="custom-h4-title" id="titleDatePostale">{{ 'postalDate' | translate }}</h4>
              @if (locale4Calendar) {
                <i-input [type]="'calendar'" [iInput]="{ options: { dateFormat: 'dd/mm/yy' } }" [control]="form.get('datePostale')"> </i-input>
              }
            </div>
          </div>
          <div class="form-group mb-2">
            <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
              <div>{{ 'object' | translate }} {{ checkMatrice?.objet?.obligatoire ? '*' : '' }}</div>
              @if (!f.objet.value || f.objet.value === '') {
                <span (click)="openObjectBibli()">
                  <svg
                    style="cursor: pointer"
                    width="15px"
                    height="15px"
                    viewBox="0 0 15 15"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Medium-Copy-19" transform="translate(-449.000000, -315.000000)" fill="#60CDFF" fill-rule="nonzero">
                        <g id="noun-library-3187847" transform="translate(449.000000, 315.000000)">
                          <path
                            d="M3.5,2 L0.5,2 C0.367411429,2 0.240177143,2.05268 0.146428571,2.14642857 C0.05268,2.24017714 0,2.36741143 0,2.5 L0,14.5 C0,14.6325886 0.05268,14.7598229 0.146428571,14.8535714 C0.240177143,14.94732 0.367411429,15 0.5,15 L3.5,15 C3.63258857,15 3.75982286,14.94732 3.85357143,14.8535714 C3.94732,14.7598229 4,14.6325886 4,14.5 L4,2.5 C4,2.36741143 3.94732,2.24017714 3.85357143,2.14642857 C3.75982286,2.05268 3.63258857,2 3.5,2 Z M2.50000714,13.5 L1.50000714,13.5 C1.32131714,13.5 1.15625714,13.4046886 1.06697143,13.25 C0.977685714,13.0953114 0.977685714,12.9046857 1.06697143,12.75 C1.15625714,12.5953143 1.32132286,12.5 1.50000714,12.5 L2.50000714,12.5 C2.67868286,12.5 2.84374286,12.5953114 2.93302857,12.75 C3.02231429,12.9046886 3.02231429,13.0953143 2.93302857,13.25 C2.84374286,13.4046857 2.67867714,13.5 2.50000714,13.5 Z M2.50000714,12 L1.50000714,12 C1.32131714,12 1.15625714,11.9046886 1.06697143,11.75 C0.977685714,11.5953114 0.977685714,11.4046857 1.06697143,11.25 C1.15625714,11.0953143 1.32132286,11 1.50000714,11 L2.50000714,11 C2.67868286,11 2.84374286,11.0953114 2.93302857,11.25 C3.02231429,11.4046886 3.02231429,11.5953143 2.93302857,11.75 C2.84374286,11.9046857 2.67867714,12 2.50000714,12 Z"
                            id="Shape"></path>
                          <path
                            d="M14.9865373,13.5700086 L12.3097279,1.90000857 C12.280121,1.77054571 12.2020244,1.65860286 12.0929286,1.58918 C11.983723,1.51976 11.8525285,1.49844286 11.728205,1.53002857 L8.84468856,2.24497143 L8.84468856,0.5 C8.84468856,0.367411429 8.79405401,0.240177143 8.7039455,0.146428571 C8.61383698,0.05268 8.49154293,0 8.36410249,0 L5.48058607,0 C5.35314563,0 5.23085158,0.05268 5.14074306,0.146428571 C5.05063455,0.240177143 5,0.367411429 5,0.5 L5,14.5 C5,14.6325886 5.05063455,14.7598229 5.14074306,14.8535714 C5.23085158,14.94732 5.35314563,15 5.48058607,15 L8.36410249,15 C8.49154293,15 8.61383698,14.94732 8.7039455,14.8535714 C8.79405401,14.7598229 8.84468856,14.6325886 8.84468856,14.5 L8.84468856,4.36485714 L11.1706977,14.5 C11.1961215,14.6118314 11.2576975,14.7112714 11.3452328,14.7813629 C11.4327681,14.8514543 11.5409,14.88806 11.6512975,14.8850457 L11.7617883,14.8850457 L14.6453048,14.1701029 L14.645412,14.1699913 C14.7660941,14.1359513 14.869291,14.0541427 14.9330222,13.9420884 C14.9967424,13.8300341 15.0159439,13.6965513 14.9865512,13.5700027 L14.9865373,13.5700086 Z M6.92230309,2.00000857 C7.04974353,2.00000857 7.17203758,2.05268857 7.26214609,2.14643714 C7.35225461,2.24018571 7.40288916,2.36742 7.40288916,2.50000857 C7.40288916,2.63259714 7.35225461,2.75983143 7.26214609,2.85358 C7.17203758,2.94732857 7.04974353,3.00000857 6.92230309,3.00000857 C6.79486265,3.00000857 6.6725686,2.94732857 6.58246008,2.85358 C6.49235157,2.75983143 6.44171702,2.63259714 6.44171702,2.50000857 C6.44171702,2.36742 6.49235157,2.24018571 6.58246008,2.14643714 C6.6725686,2.05268857 6.79486265,2.00000857 6.92230309,2.00000857 Z M7.40288916,13.5000086 L6.44171702,13.5000086 C6.26997203,13.5000086 6.11132096,13.4046971 6.02550202,13.2500086 C5.93968308,13.09532 5.93968308,12.9046943 6.02550202,12.7500086 C6.11132096,12.5953229 6.26997753,12.5000086 6.44171702,12.5000086 L7.40288916,12.5000086 C7.57463414,12.5000086 7.73328522,12.59532 7.81910416,12.7500086 C7.9049231,12.9046971 7.9049231,13.0953229 7.81910416,13.2500086 C7.73328522,13.4046943 7.57462865,13.5000086 7.40288916,13.5000086 Z M7.40288916,12.0000086 L6.44171702,12.0000086 C6.26997203,12.0000086 6.11132096,11.9046971 6.02550202,11.7500086 C5.93968308,11.59532 5.93968308,11.4046943 6.02550202,11.2500086 C6.11132096,11.0953229 6.26997753,11.0000086 6.44171702,11.0000086 L7.40288916,11.0000086 C7.57463414,11.0000086 7.73328522,11.09532 7.81910416,11.2500086 C7.9049231,11.4046971 7.9049231,11.5953229 7.81910416,11.7500086 C7.73328522,11.9046943 7.57462865,12.0000086 7.40288916,12.0000086 Z M13.3333213,13.0000086 L12.3961784,13.2300314 L12.2856876,13.2300314 C12.1139426,13.2505671 11.9447735,13.1742286 11.8417908,13.0298086 C11.7389152,12.8853886 11.7177831,12.6947514 11.7865454,12.5298086 C11.8553076,12.3648543 12.0034517,12.2505686 12.1750786,12.2300371 L13.1122215,12.0000143 C13.2839664,11.9589429 13.4636535,12.0163089 13.5836901,12.15046 C13.7037268,12.2846111 13.7458866,12.4751171 13.6942881,12.65046 C13.6425825,12.8256829 13.505058,12.9589457 13.3332993,13.0000029 L13.3333213,13.0000086 Z"
                            id="Shape"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span class="bibliothequeObjet__blue ms-1">{{ 'objectsLibrary' | translate }} </span>
                </span>
              }
              @if (rightUser?.menu?.mails && f.objet.value) {
                <span (click)="openObjectCreate()">
                  <svg
                    style="cursor: pointer"
                    width="15px"
                    height="15px"
                    viewBox="0 0 15 15"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Medium-Copy-19" transform="translate(-449.000000, -315.000000)" fill="#3BDE86" fill-rule="nonzero">
                        <g id="noun-library-3187847" transform="translate(449.000000, 315.000000)">
                          <path
                            d="M3.5,2 L0.5,2 C0.367411429,2 0.240177143,2.05268 0.146428571,2.14642857 C0.05268,2.24017714 0,2.36741143 0,2.5 L0,14.5 C0,14.6325886 0.05268,14.7598229 0.146428571,14.8535714 C0.240177143,14.94732 0.367411429,15 0.5,15 L3.5,15 C3.63258857,15 3.75982286,14.94732 3.85357143,14.8535714 C3.94732,14.7598229 4,14.6325886 4,14.5 L4,2.5 C4,2.36741143 3.94732,2.24017714 3.85357143,2.14642857 C3.75982286,2.05268 3.63258857,2 3.5,2 Z M2.50000714,13.5 L1.50000714,13.5 C1.32131714,13.5 1.15625714,13.4046886 1.06697143,13.25 C0.977685714,13.0953114 0.977685714,12.9046857 1.06697143,12.75 C1.15625714,12.5953143 1.32132286,12.5 1.50000714,12.5 L2.50000714,12.5 C2.67868286,12.5 2.84374286,12.5953114 2.93302857,12.75 C3.02231429,12.9046886 3.02231429,13.0953143 2.93302857,13.25 C2.84374286,13.4046857 2.67867714,13.5 2.50000714,13.5 Z M2.50000714,12 L1.50000714,12 C1.32131714,12 1.15625714,11.9046886 1.06697143,11.75 C0.977685714,11.5953114 0.977685714,11.4046857 1.06697143,11.25 C1.15625714,11.0953143 1.32132286,11 1.50000714,11 L2.50000714,11 C2.67868286,11 2.84374286,11.0953114 2.93302857,11.25 C3.02231429,11.4046886 3.02231429,11.5953143 2.93302857,11.75 C2.84374286,11.9046857 2.67867714,12 2.50000714,12 Z"
                            id="Shape"></path>
                          <path
                            d="M14.9865373,13.5700086 L12.3097279,1.90000857 C12.280121,1.77054571 12.2020244,1.65860286 12.0929286,1.58918 C11.983723,1.51976 11.8525285,1.49844286 11.728205,1.53002857 L8.84468856,2.24497143 L8.84468856,0.5 C8.84468856,0.367411429 8.79405401,0.240177143 8.7039455,0.146428571 C8.61383698,0.05268 8.49154293,0 8.36410249,0 L5.48058607,0 C5.35314563,0 5.23085158,0.05268 5.14074306,0.146428571 C5.05063455,0.240177143 5,0.367411429 5,0.5 L5,14.5 C5,14.6325886 5.05063455,14.7598229 5.14074306,14.8535714 C5.23085158,14.94732 5.35314563,15 5.48058607,15 L8.36410249,15 C8.49154293,15 8.61383698,14.94732 8.7039455,14.8535714 C8.79405401,14.7598229 8.84468856,14.6325886 8.84468856,14.5 L8.84468856,4.36485714 L11.1706977,14.5 C11.1961215,14.6118314 11.2576975,14.7112714 11.3452328,14.7813629 C11.4327681,14.8514543 11.5409,14.88806 11.6512975,14.8850457 L11.7617883,14.8850457 L14.6453048,14.1701029 L14.645412,14.1699913 C14.7660941,14.1359513 14.869291,14.0541427 14.9330222,13.9420884 C14.9967424,13.8300341 15.0159439,13.6965513 14.9865512,13.5700027 L14.9865373,13.5700086 Z M6.92230309,2.00000857 C7.04974353,2.00000857 7.17203758,2.05268857 7.26214609,2.14643714 C7.35225461,2.24018571 7.40288916,2.36742 7.40288916,2.50000857 C7.40288916,2.63259714 7.35225461,2.75983143 7.26214609,2.85358 C7.17203758,2.94732857 7.04974353,3.00000857 6.92230309,3.00000857 C6.79486265,3.00000857 6.6725686,2.94732857 6.58246008,2.85358 C6.49235157,2.75983143 6.44171702,2.63259714 6.44171702,2.50000857 C6.44171702,2.36742 6.49235157,2.24018571 6.58246008,2.14643714 C6.6725686,2.05268857 6.79486265,2.00000857 6.92230309,2.00000857 Z M7.40288916,13.5000086 L6.44171702,13.5000086 C6.26997203,13.5000086 6.11132096,13.4046971 6.02550202,13.2500086 C5.93968308,13.09532 5.93968308,12.9046943 6.02550202,12.7500086 C6.11132096,12.5953229 6.26997753,12.5000086 6.44171702,12.5000086 L7.40288916,12.5000086 C7.57463414,12.5000086 7.73328522,12.59532 7.81910416,12.7500086 C7.9049231,12.9046971 7.9049231,13.0953229 7.81910416,13.2500086 C7.73328522,13.4046943 7.57462865,13.5000086 7.40288916,13.5000086 Z M7.40288916,12.0000086 L6.44171702,12.0000086 C6.26997203,12.0000086 6.11132096,11.9046971 6.02550202,11.7500086 C5.93968308,11.59532 5.93968308,11.4046943 6.02550202,11.2500086 C6.11132096,11.0953229 6.26997753,11.0000086 6.44171702,11.0000086 L7.40288916,11.0000086 C7.57463414,11.0000086 7.73328522,11.09532 7.81910416,11.2500086 C7.9049231,11.4046971 7.9049231,11.5953229 7.81910416,11.7500086 C7.73328522,11.9046943 7.57462865,12.0000086 7.40288916,12.0000086 Z M13.3333213,13.0000086 L12.3961784,13.2300314 L12.2856876,13.2300314 C12.1139426,13.2505671 11.9447735,13.1742286 11.8417908,13.0298086 C11.7389152,12.8853886 11.7177831,12.6947514 11.7865454,12.5298086 C11.8553076,12.3648543 12.0034517,12.2505686 12.1750786,12.2300371 L13.1122215,12.0000143 C13.2839664,11.9589429 13.4636535,12.0163089 13.5836901,12.15046 C13.7037268,12.2846111 13.7458866,12.4751171 13.6942881,12.65046 C13.6425825,12.8256829 13.505058,12.9589457 13.3332993,13.0000029 L13.3333213,13.0000086 Z"
                            id="Shape"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span class="bibliothequeObjet__green ms-1">{{ 'addToObjectsLibrary' | translate }}</span>
                </span>
              }
            </h4>
            <textarea class="w-100" pInputTextarea [rows]="3" formControlName="objet" name="objet" id="createCourrierObjet"></textarea>
            @if (f.objet.dirty && f.objet.invalid && f.objet?.errors['maxlength']) {
              <div class="input-error">{{ 'objectCanNotBeAbove4000Chars' | translate }}</div>
            }
            @if (checkMatrice?.objet?.warning === true && checkMatrice?.objet?.obligatoire === false) {
              <div class="input-warning">{{ 'recommendedToAddObject' | translate }}</div>
            }
            @if (checkMatrice?.objet?.obligatoire === true) {
              <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
            }
          </div>
          @if (form.value.typeEntrantSortant === 'E') {
            <div class="mb-3">
              <i-tabs class="box" [items]="actionTabs" (tabChange)="onChangeTabsExpediteurs($event)"></i-tabs>
            </div>
          }
          <div class="row">
            @if (expediteurTabsActive === 'existing') {
              <div class="form-group col-12 mb-2">
                <div class="row">
                  <div class="col-12 mb-3 align-items-center">
                    <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                      <div>
                        {{ 'sender' | translate }}
                        {{ checkMatrice?.expediteur?.obligatoire || typeEntrantSortant === 'S' || typeEntrantSortant === 'I' ? '*' : '' }}
                        @if (typeEntrantSortant === 'E') {
                          <i
                            class="bi bi-info-circle ms-2"
                            pTooltip="Veuillez entrer 3 lettres minimum afin d'effectuer une recherche"
                            tooltipPosition="top"></i>
                        }
                      </div>
                      <div class="cta__right">
                        <i class="bi bi-search cursor--pointer" (click)="openModalSearchSender()"></i>
                      </div>
                    </h4>
                    <div class="d-flex align-items-center p-fluid">
                      @if (typeEntrantSortant === 'E') {
                        <p-toggleButton
                          styleClass="custom-toggle-button_advancedSearch"
                          [onLabel]="'mainNav.contacts' | translate"
                          [offLabel]="'mainNav.users' | translate"
                          [onIcon]="'bi bi-person-vcard'"
                          [offIcon]="'bi bi-person'"
                          [(ngModel)]="recipientSourceBoolean"
                          [ngModelOptions]="{ standalone: true }"
                          (onChange)="onChangeToggleButtonUsersContacts($event)"></p-toggleButton>
                      }
                      @if (typeEntrantSortant === 'E') {
                        <p-autoComplete
                          #autocomplete
                          id="expediteursAutocomplete"
                          type="search"
                          class="w-100"
                          styleClass="custom-multi-select_advancedSearch"
                          field="label"
                          dataKey="value"
                          [formControl]="formControlNameForExpediteur"
                          [showEmptyMessage]="true"
                          [placeholder]="'pleaseSelectASender' | translate"
                          [suggestions]="filteredExpediteurs | sort: 'label' : 'ASC'"
                          (completeMethod)="searchSenderAutoComplete($event)"
                          (onSelect)="onSelectSender($event)">
                          <ng-template let-selectedItem pTemplate="selectedItem"> {{ selectedItem.label }} </ng-template>
                          <ng-template let-contact pTemplate="item">
                            @if (form.value.recipientSource === 'iAdmin') {
                              <div>
                                <div class="expediteursDropdown__label">{{ contact?.label }}</div>
                              </div>
                            }
                            @if (form.value.recipientSource === 'iCourrier') {
                              <div
                                class="d-flex align-items-center justify-content-between"
                                pTooltip="{{ contact?.label + '<br>' }} {{
                                  contact?.nameTypeContact ? 'Type: ' + contact.nameTypeContact + '<br>' : null
                                }} {{ contact?.adresse ? 'Adresse: ' + contact?.adresse : 'Adresse: /' + '<br>' }}"
                                tooltipPosition="bottom">
                                <div class="expediteursDropdown__label">{{ contact?.label }}</div>
                                <div class="d-flex align-items-center" style="width: fit-content">
                                  <i class="bi bi-info-circle me-2" (click)="showMoreInfoContact(contact); display = true"></i>
                                  <i class="bi bi-pencil-fill iconSmaller ms-1" (click)="openUpdateUser(contact)"></i>
                                </div>
                              </div>
                            }
                          </ng-template>
                          <ng-template let-item pTemplate="empty">
                            <div class="d-flex align-items-center justify-content-between">{{ 'noContactFound' | translate }}</div>
                          </ng-template>
                        </p-autoComplete>
                      }
                      @if (contacts.length > 0 && (typeEntrantSortant === 'S' || typeEntrantSortant === 'I')) {
                        <p-dropdown
                          id="expediteursDropdown"
                          [showClear]="true"
                          [options]="contacts | removeEmptyLabel: 'label' | sort: 'label' : 'ASC'"
                          [placeholder]="'pleaseSelectASender' | translate"
                          [filter]="true"
                          class="w-100"
                          styleClass="custom-multi-select_advancedSearch dropdown-inforius"
                          [formControl]="formControlNameForExpediteur"
                          autocomplete="new-password"
                          name="expediteurId"
                          [emptyFilterMessage]="'noResultFound' | translate"
                          [virtualScroll]="true"
                          [virtualScrollItemSize]="31">
                          <ng-template let-item pTemplate="selectedItem"> {{ item?.label }} </ng-template>
                          <ng-template let-contact pTemplate="item">
                            <div
                              class="d-flex align-items-center justify-content-between"
                              pTooltip="{{ contact?.label + '<br>' }} {{
                                contact?.nameTypeContact ? 'Type: ' + contact.nameTypeContact + '<br>' : null
                              }} {{ contact?.adresse ? 'Adresse: ' + contact?.adresse : 'Adresse: /' + '<br>' }}"
                              tooltipPosition="bottom">
                              <div class="expediteursDropdown__label">{{ contact?.label }}</div>
                              <div class="d-flex align-items-center" style="width: fit-content">
                                <i class="bi bi-info-circle me-2" (click)="showMoreInfoContact(contact); display = true"></i>
                                <i class="bi bi-pencil-fill iconSmaller ms-1" (click)="openUpdateUser(contact)"></i>
                              </div>
                            </div>
                          </ng-template>
                        </p-dropdown>
                      }
                      @if (checkMatrice?.expediteur?.obligatoire && !f.expediteurId.value) {
                        <div class="input-error" id="noExpediteurText">{{ 'editCourrier.senderRequired' | translate }}</div>
                      }
                      @if (checkMatrice?.expediteur?.warning === true && !f.expediteurId.value) {
                        <div class="input-warning" id="recommendedExpediteur">{{ 'recommendedToAddSender' | translate }}</div>
                      }
                      @if (
                        !serviceProprietaireId &&
                        !form.value.serviceProprietaireId &&
                        (form.value.typeEntrantSortant === 'S' || form.value.typeEntrantSortant === 'I')
                      ) {
                        <div class="input-warning">{{ 'pleaseSelectAServiceForExpeditors' | translate }}</div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (expediteurTabsActive === 'new') {
              <div class="form-group col-12 mb-2">
                <app-contact-new-simple
                  [savingNewExpFromCourrier]="isSavingNewExpediteur.asObservable()"
                  (canSaveContact)="receiveCanSaveContact($event)"
                  (contactIsSaved)="contactFormToBeSaved($event)"></app-contact-new-simple>
              </div>
            }
            @if (expediteurTabsActive === 'free') {
              <div class="form-group col-12 mb-2">
                <textarea
                  rows="5"
                  cols="30"
                  [placeholder]="'encodeFreeSender' | translate"
                  formControlName="expediteurLibre"
                  class="super-compos-input-text form-control w-100"
                  [attr.data-test]="'expediteur-libre'"
                  pInputTextarea></textarea>
                @if (checkMatrice?.expediteur?.obligatoire && !f.expediteurLibre.value) {
                  <div class="input-error">{{ 'freeSenderRequired' | translate }}</div>
                }
                @if (checkMatrice?.expediteur?.warning === true && !f.expediteurLibre.value) {
                  <div class="input-warning" id="recommendedExpediteur">{{ 'recommendedToAddSender' | translate }}</div>
                }
              </div>
            }
            @if (form.value.typeEntrantSortant === 'E') {
              <div class="d-flex w-100 justify-content-center mb-3" style="border-bottom: 1px solid rgba(151, 151, 151, 0.5)"></div>
            }
          </div>
          @if (configuration?.mails?.hideClassementDossiers === false) {
            <div class="row">
              @if (codesclassementsLV.length > 0 && checkMatrice?.codeClassement?.invisible === false) {
                <div class="form-group col-12 mb-2">
                  <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                    {{ 'classificationCode' | translate }} {{ checkMatrice?.codeClassement?.obligatoire ? '*' : '' }}
                    <div class="cta__right">
                      @if (rightUser?.menu?.codesClassement) {
                        <i class="bi bi-plus-circle-fill greenIcon cursor--pointer me-2" (click)="openAddClassement()"></i>
                      }
                      <i
                        class="bi bi-search cursor--pointer"
                        [ngClass]="{ 'bi-search__grayIcon': !form.value.serviceProprietaireId }"
                        [pTooltip]="getTooltipForClassificationSearch()"
                        (click)="openModalClassement()"></i>
                    </div>
                  </h4>
                  <p-dropdown
                    [showClear]="true"
                    [options]="codesclassementsLV | sort: 'label' : 'ASC'"
                    [placeholder]="'pleaseSelectACodeClassification' | translate"
                    [filter]="true"
                    styleClass="w-100 dropdown-inforius"
                    formControlName="classementId"
                    appendTo="body"
                    autocomplete="new-password"
                    [emptyFilterMessage]="'noResultFound' | translate"
                    id="classementId"
                    (onShow)="isDropdownToggled = true; moveAutocomplete()"
                    (onHide)="isDropdownToggled = false; onHideClassementMethod()"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="31"
                    [attr.data-test]="'classement'"
                    (onChange)="onChangeClassement()">
                    <ng-template let-selectedItem pTemplate="selectedItem"> {{ selectedItem?.label }} </ng-template>
                    <ng-template let-item pTemplate="item">
                      <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                        <div [pTooltip]="item.label">{{ item?.label }}</div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  @if (checkMatrice?.codeClassement?.warning === true && checkMatrice?.codeClassement?.obligatoire === false) {
                    <div class="input-warning">{{ 'recommendedToAddClassification' | translate }}</div>
                  }
                  @if (checkMatrice?.codeClassement?.obligatoire === true) {
                    <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                  }
                  @if (codesclassementsLV.length === 0) {
                    <div class="form-group col-4 input-warning">{{ 'pleaseSelectServiceToSeeClassifications' | translate }}</div>
                  }
                  @if (checkMatrice?.codeClassement?.warning === true && checkMatrice?.codeClassement?.obligatoire === false) {
                    <p-skeleton height="2.5rem" class="col-12"></p-skeleton>
                  }
                </div>
              }
              <!-- JIRA 2806 : Vu avec MPE => Afficher au moins le titre ssi l'item précédent existe -->
              @if (form.value.classementId && checkMatrice?.codeClassement?.invisible === false && form.value.serviceProprietaireId) {
                <div class="form-group col-12 mb-2">
                  <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                    <div>
                      {{ 'folder' | translate }}
                      <p-checkbox
                        class="ms-1"
                        binary="true"
                        [(ngModel)]="classeurCheckArchived"
                        [ngModelOptions]="{ standalone: true }"
                        (onChange)="displayArchived('classeur', $event)"></p-checkbox>
                      <span class="displayArchivedClassementLabel">{{ 'displayArchived' | translate }}</span>
                    </div>
                    @if (rightUser?.menu.classementDossiers === true || rightUser.menu.classementDossiersPartiel === true) {
                      <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openAddFarde()"></i>
                    }
                  </h4>
                  @if (classeursLV.length > 0) {
                    <p-dropdown
                      [showClear]="true"
                      [options]="classeursLV | sort: 'label' : 'ASC'"
                      [placeholder]="'pleaseSelectAFolder' | translate"
                      [filter]="true"
                      styleClass="w-100 dropdown-inforius"
                      formControlName="classeurId"
                      appendTo="body"
                      autocomplete="new-password"
                      [emptyFilterMessage]="'noResultFound' | translate"
                      id="classeurId"
                      (onShow)="moveAutocomplete()"
                      [attr.data-test]="'classeur'"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="31"
                      (onChange)="getChemises($event.value)">
                      <ng-template let-item pTemplate="selectedItem">
                        @if (item?.partage) {
                          <i class="bi bi-people-fill"></i>
                        }
                        {{ item?.label }}
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                          <div [pTooltip]="item.label">
                            @if (item?.partage) {
                              <i class="bi bi-people-fill me-1"></i>
                            }
                            {{ item?.label }}
                          </div>
                        </div>
                      </ng-template>
                    </p-dropdown>
                  }
                  @if (classeursLV.length === 0) {
                    <div class="form-group col-4 input-warning">{{ 'noFolderAvailable' | translate }}</div>
                  }
                  @if (loadingClasseurChemise) {
                    <p-skeleton height="2.5rem" class="col-12"></p-skeleton>
                  }
                </div>
              }
              <!-- JIRA 2806 : Vu avec MPE => Afficher au moins le titre ssi l'item précédent existe -->
              @if (form.value.classeurId && checkMatrice?.codeClassement?.invisible === false && form.value.serviceProprietaireId) {
                <div class="form-group col-12 mb-2">
                  <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                    <div>
                      {{ 'plasticLiner' | translate }} *
                      <!-- on rend obligatoire car si une farde est choisie ALORS la chemise sera obligatoire -->
                      <p-checkbox
                        class="ms-1"
                        binary="true"
                        [(ngModel)]="chemiseCheckArchived"
                        [ngModelOptions]="{ standalone: true }"
                        (onChange)="displayArchived('chemise', $event)"></p-checkbox>
                      <span class="displayArchivedClassementLabel">{{ 'displayArchived' | translate }}</span>
                    </div>
                    @if (rightUser?.menu.classementDossiers === true || rightUser.menu.classementDossiersPartiel === true) {
                      <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openAddChemise()"></i>
                    }
                  </h4>
                  @if (chemisesLV.length > 0) {
                    <p-dropdown
                      [showClear]="true"
                      [options]="chemisesLV | sort: 'label' : 'ASC'"
                      [placeholder]="'pleaseSelectAPlasticLiner' | translate"
                      [filter]="true"
                      styleClass="w-100 dropdown-inforius"
                      formControlName="chemiseId"
                      appendTo="body"
                      autocomplete="new-password"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="31"
                      [emptyFilterMessage]="'noResultFound' | translate"
                      id="chemiseId"
                      (onShow)="moveAutocomplete()"
                      [attr.data-test]="'chemise'">
                      <ng-template let-item pTemplate="selectedItem">
                        @if (item?.partage) {
                          <i class="bi bi-people-fill"></i>
                        }
                        {{ item?.label }}
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                          <div [pTooltip]="item.label">
                            @if (item?.partage) {
                              <i class="bi bi-people-fill me-1"></i>
                            }
                            {{ item?.label }}
                          </div>
                        </div>
                      </ng-template>
                    </p-dropdown>
                  }
                  @if (chemisesLV.length === 0) {
                    <div class="form-group col-4 input-warning">{{ 'noPLasticLinerAvailable' | translate }}</div>
                  }
                  @if (loadingClasseurChemise) {
                    <p-skeleton height="2.5rem" class="col-12"></p-skeleton>
                  }
                </div>
              }
            </div>
          }
          <div class="row">
            <div class="complementary-data-container col-12 mb-2">
              @if (checkMatrice?.nature?.invisible === false) {
                <div class="form-group col-12">
                  <h4 class="custom-h4-title">
                    {{ 'nature' | translate }} {{ checkMatrice?.nature?.obligatoire || configuration?.mails?.obligationNature ? '*' : '' }}
                    @if (rightUser?.menu?.mails) {
                      <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openNatureCreate('typeNature')"></i>
                    }
                  </h4>
                  <p-dropdown
                    [showClear]="true"
                    #Dropdown
                    [options]="natureListLV"
                    [placeholder]="'pleaseSelectANature' | translate"
                    [filter]="true"
                    styleClass="w-100 dropdown-inforius"
                    appendTo="body"
                    autocomplete="new-password"
                    formControlName="natureId"
                    (onChange)="changeNature($event.value); checkForComplementaryData($event.value)"
                    id="dropdown"
                    [emptyFilterMessage]="'noResultFound' | translate"
                    (onShow)="moveAutocomplete()"
                    [readonly]="checkMatrice?.nature?.lectureSeule">
                  </p-dropdown>
                  @if (checkMatrice?.nature?.warning === true && checkMatrice?.nature?.obligatoire === false) {
                    <div class="input-warning">{{ 'recommendedToAddNature' | translate }}</div>
                  }
                  @if (checkMatrice?.nature?.obligatoire === true) {
                    <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                  }
                </div>
              }
              @if (dataToPrepareForForm?.controls?.length > 0 && !loadingComplementaryDatas) {
                <div class="complementdata col-md-12">
                  <app-complement-data-form
                    [mode]="'update'"
                    [natureWithComplementaryDatas]="natureWithComplementaryDatas"
                    [formData]="dataToPrepareForForm"
                    (formValue)="receive_complementData($event)"></app-complement-data-form>
                </div>
              }
            </div>
            @if (checkMatrice?.source?.invisible === false) {
              <div class="form-group col-6">
                <h4 class="custom-h4-title">
                  {{ 'source' | translate }} {{ checkMatrice?.source?.obligatoire || configuration?.mails?.obligationSource ? '*' : '' }}
                  @if (rightUser?.menu?.mails) {
                    <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openNatureCreate('typeSource')"></i>
                  }
                </h4>
                <div class="row">
                  <div class="col-md-12" [ngClass]="{ 'col-md-6': showRefRecommanded }">
                    <p-dropdown
                      [showClear]="true"
                      [options]="sourceListLV | sort: 'label' : 'ASC'"
                      [placeholder]="'pleaseSelectASource' | translate"
                      [filter]="true"
                      autocomplete="new-password"
                      styleClass="w-100 dropdown-inforius"
                      appendTo="body"
                      (onChange)="showRef($event.value)"
                      formControlName="sourceId"
                      #Dropdown
                      id="dropdown"
                      [emptyFilterMessage]="'noResultFound' | translate"
                      (onShow)="moveAutocomplete()"
                      [readonly]="checkMatrice?.source?.lectureSeule">
                    </p-dropdown>
                    @if (checkMatrice?.source?.warning === true && checkMatrice?.source?.obligatoire === false) {
                      <div class="input-warning">{{ 'recommendedToAddSource' | translate }}</div>
                    }
                    @if (checkMatrice?.source?.obligatoire === true) {
                      <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                    }
                  </div>
                  @if (showRefRecommanded && checkMatrice?.refRecommande?.invisible === false) {
                    <div class="col-md-6">
                      <label>{{ 'registeredMailReference' | translate }} {{ checkMatrice?.refRecommande?.obligatoire ? '*' : '' }}</label>
                      <i-input
                        [iInput]="{ placeholder: '' }"
                        [type]="'text'"
                        [control]="form.get('referenceRecommande')"
                        [showError]="false"
                        styleClass="d-block w-100"></i-input>
                      @if (checkMatrice?.refRecommande?.warning === true && checkMatrice?.refRecommande?.obligatoire === false) {
                        <div class="input-warning">{{ 'recommendedToAddRegisteredMailReference' | translate }}</div>
                      }
                      @if (checkMatrice?.refRecommande?.obligatoire === true) {
                        <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="row">
            @if (!selectedUserService || (selectedUserService && !selectedUserService.cacherStatutsMultiples)) {
              <div class="form-group col-6">
                <h4 class="custom-h4-title">{{ 'documentStatus' | translate }}</h4>
                <p-dropdown
                  [showClear]="true"
                  [options]="statutListLV | sort: 'ordre' : 'ASC'"
                  [placeholder]="'pleaseSelectAStatus' | translate"
                  [filter]="true"
                  autocomplete="new-password"
                  styleClass="w-100 dropdown-inforius"
                  appendTo="body"
                  formControlName="statutId"
                  id="statutId"
                  [emptyFilterMessage]="'noResultFound' | translate">
                  <ng-template let-item pTemplate="selectedItem"
                    ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
                  >
                </p-dropdown>
              </div>
            }
            @if (checkMatrice?.boiteArchive?.invisible === false) {
              <div class="form-group col-6">
                <h4 class="custom-h4-title">{{ 'editCourrier.archiveBox' | translate }} {{ checkMatrice?.boiteArchive?.obligatoire ? '*' : '' }}</h4>
                <input
                  type="text"
                  pInputText
                  class="super-compos-input-text form-control w-100"
                  formControlName="boiteArchive"
                  [readonly]="checkMatrice?.boiteArchive?.lectureSeule"
                  [attr.data-test]="'boite-archive'" />
                @if (checkMatrice?.boiteArchive?.warning === true && checkMatrice?.boiteArchive?.obligatoire === false) {
                  <div class="input-warning">{{ 'editCourrier.addArchiveBoxRecommended' | translate }}</div>
                }
                @if (checkMatrice?.boiteArchive?.obligatoire === true) {
                  <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                }
              </div>
            }
          </div>
          <div class="row">
            @if (checkMatrice?.remarques?.invisible === false) {
              <div class="form-group col-12">
                <h4 class="custom-h4-title">{{ 'remarks' | translate }} {{ checkMatrice?.remarques?.obligatoire ? '*' : '' }}</h4>
                <textarea class="w-100" pInputTextarea [rows]="3" formControlName="remarques" id="remarques"></textarea>
                @if (checkMatrice?.remarques?.warning === true && checkMatrice?.remarques?.obligatoire === false) {
                  <div class="input-warning">{{ 'recommendedToAddRemark' | translate }}</div>
                }
                @if (checkMatrice?.remarques?.obligatoire === true) {
                  <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                }
              </div>
            }
          </div>
        </div>
      } @else {
        <app-courrier-details-general-infos
          [courrier]="courrier ? courrier : tempMail"
          [sourceList]="sourceList"
          [natureList]="natureList"
          [configuration]="configuration"
          [tags]="tags"
          [tagsCourrier]="tagsCourrier"
          [rightFlux]="null"
          [rightMail]="null"
          [rightManagement]="null"
          [userServices]="userServices"
          [readonly]="true"
          [servicesChildParent]="servicesFusionned"
          [groupsMemberUserConnected]="null"></app-courrier-details-general-infos>
        <!-- Info : certaines infos sont a null car comme c'est readonly, pas besoin de ces infos la -->
      }
    </form>
  </div>
}

<!-- $$$$$$$$$$ FORM for create in modal $$$$$$$$$$$ -->

@if (isNew && isLoaded) {
  <div>
    <form [formGroup]="form" class="form mt-4" (change)="onFormChange()" autocomplete="new-password">
      @if (!scan) {
        <div>
          <p-fileUpload
            [multiple]="true"
            showUploadButton="false"
            showCancelButton="false"
            styleClass="fileUploadCustom"
            id="pMailUpload2"
            #pMailUpload2
            class="d-block"
            name="myfile[]"
            (onSelect)="dragAttachement($event)">
          </p-fileUpload>
        </div>
      }
      @if (!scan) {
        <div class="d-flex justify-content-end mb-2">
          <i-button text="Joindre un fichier..." styleClass="green" (click)="onUploadClick()"></i-button>
        </div>
      }
      <div class="row" formGroupName="lien">
        <div class="col-md-9 p-fluid">
          <h4 class="custom-h4-title">{{ 'courrierFiche.linkMail' | translate }}</h4>
          <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="form.get('lien.linkCourrierId')" styleClass="d-block w-100"> </i-input>
        </div>
        <div class="col-md-3">
          <h4 class="custom-h4-title">{{ 'courrierFiche.relationType' | translate }}</h4>
          <p-dropdown
            [options]="typesLV"
            appendTo="body"
            [placeholder]="'courrierFiche.chooseRelation' | translate"
            formControlName="typeLiaison"
            [filter]="true"
            [emptyFilterMessage]="'courrierFiche.noResultsFound' | translate"
            [showClear]="true">
            <ng-template let-item pTemplate="selectedItem"
              ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
            >
          </p-dropdown>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6">
          <label class="containerc mb-0">
            {{ 'annexesNonScannees' | translate }}
            <input
              type="checkbox"
              formControlName="annexeNonScannee"
              class="super-compos-input-text form-control"
              id="annexeNonScannee"
              data-test="annexeNonScannee-checkbox" />
            <span class="checkmark chek-menu"></span>
          </label>
        </div>
        @if (form.value.annexeNonScannee) {
          <div class="col-md-6">
            <label class="containerc mb-0">
              {{ 'annexeDiffusee' | translate }}
              <input
                type="checkbox"
                formControlName="annexeDiffusee"
                class="super-compos-input-text form-control"
                id="annexeDiffusee"
                data-test="annexeDiffusee-checkbox" />
              <span class="checkmark chek-menu"></span>
            </label>
          </div>
        }
        @if (form.value.annexeNonScannee) {
          <div class="col-md-12">
            <label class="custom-h4-title noPaddingLeft"> {{ 'nombreAnnexesNonScannees' | translate }}</label>
            <i-input
              [type]="'number'"
              [iInput]="{ placeholder: 'nombreAnnexesNonScannees' | translate }"
              [control]="form.get('annexeNonScanneeNombre')"
              styleClass="d-block w-100">
            </i-input>
          </div>
        }
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div class="justify-content-start">
          <h4 class="custom-h4-title" id="titleType">Type *</h4>
          @if ((!selectedUserService || selectedUserService?.refuserCreationEntrant === false) && userInfos?.encodageNouveauEntrant) {
            <label class="containerr d-inline-flex justify-content-start"
              >Entrant
              <input
                type="radio"
                value="E"
                formControlName="typeEntrantSortant"
                id="typeEntrantSortant"
                (click)="changeServiceByType('E'); typeChange('E')"
                data-test="type-checkbox" />
              <span class="checkmarkr" id="radioButtonTypeEntrant"></span>
            </label>
          }
          @if ((!selectedUserService || selectedUserService?.refuserCreationSortant === false) && userInfos?.encodageNouveauSortant) {
            <label class="containerr d-inline-block"
              >Sortant
              <input
                type="radio"
                value="S"
                formControlName="typeEntrantSortant"
                id="typeEntrantSortant"
                (click)="typeChange('S'); changeServiceByType('S')"
                data-test="type-checkbox" />
              <span class="checkmarkr"></span>
            </label>
          }
          <label class="containerr d-inline-block"
            >Interne
            <input
              type="radio"
              value="I"
              (click)="typeChange('I'); changeServiceByType('I')"
              formControlName="typeEntrantSortant"
              id="typeEntrantSortant"
              data-test="type-checkbox" />
            <span class="checkmarkr"></span>
          </label>
          @if (f.typeEntrantSortant.errors && f.typeEntrantSortant.errors['required']) {
            <div class="input-error">{{ 'editCourrier.courierTypeRequired' | translate }}</div>
          }
          @if (selectedUserService?.refuserCreationSortant === true) {
            <p class="input-error">{{ 'editCourrier.createOutgoingCourierDenied' | translate }}</p>
          }
          @if (selectedUserService?.refuserCreationEntrant === true) {
            <p class="input-error">{{ 'editCourrier.createIncomingCourierDenied' | translate }}</p>
          }
        </div>
        @if (rightSelectedServices === null || !rightSelectedServices?.interdireConfidentiels) {
          <div>
            <h4 class="custom-h4-title">{{ 'editCourrier.confidentiality' | translate }}</h4>
            <label class="containerc mb-0">
              {{ 'editCourrier.courrierConfidential' | translate }}
              <input
                type="checkbox"
                formControlName="confidentiel"
                class="super-compos-input-text form-control"
                id="confidentiel"
                data-test="confidential-checkbox" />
              <span class="checkmark chek-menu"></span>
            </label>
          </div>
        }
      </div>
      <div class="row mb-2">
        @if (displayWarningChildServiceDetected) {
          <div class="col-12 alert alert-info">{{ 'editCourrier.displayWarningChildServiceDetected' | translate }}</div>
        }
        <div class="form-group col-12 p-fluid">
          <h4 class="custom-h4-title">{{ 'editCourrier.service' | translate }} *</h4>
          <p-treeSelect
            [options]="showAllServices ? serviceParent : servicesOnlyParent"
            #treeSelect
            selectionMode="single"
            (onShow)="onShowTreeSelect()"
            [placeholder]="'pleaseSelectAService' | translate"
            appendTo="body"
            (onNodeSelect)="select($event); onServiceSelect($event.node.value)"
            [emptyMessage]="'noResultFound' | translate"
            [filter]="true"
            [filterPlaceholder]="'global.filterPlaceholder' | translate"
            [filterBy]="'label'"
            [filterMode]="'strict'"
            [metaKeySelection]="false"></p-treeSelect>
          @if (!selectedOption) {
            <div class="input-error">{{ 'editCourrier.serviceRequired' | translate }}</div>
          }
        </div>
      </div>
      @if (numerisations_center.length > 0 && typeEntrantSortant !== 'S') {
        <div class="row mb-2">
          <div class="form-group col-12 p-fluid">
            <h4 class="custom-h4-title">{{ 'centerNum' | translate }}</h4>
            <p-dropdown
              [showClear]="true"
              [options]="numerisations_center"
              formControlName="CentreNumerisationId"
              [placeholder]="'pleaseSelectACenterNum' | translate"
              appendTo="body"
              [filter]="true"
              styleClass="w-100 dropdown-inforius"
              [emptyFilterMessage]="'noResultFound' | translate">
            </p-dropdown>
          </div>
        </div>
      }
      @if (checkMatrice?.refExpediteur?.invisible === false) {
        <div class="row mb-2">
          <div class="form-group col-12">
            <h4 class="custom-h4-title">{{ 'editCourrier.senderRef' | translate }} {{ checkMatrice?.refExpediteur?.obligatoire ? '*' : '' }}</h4>
            <input
              formControlName="refExpediteur"
              data-test="ref-expediteur"
              name="refExpediteur"
              id="refExpediteur"
              type="text"
              autocomplete="new-password"
              class="super-compos-input-text form-control w-100"
              [readonly]="checkMatrice?.refExpediteur?.lectureSeule" />
            @if (checkMatrice?.refExpediteur?.warning === true && checkMatrice?.refExpediteur?.obligatoire === false) {
              <div class="input-warning">{{ 'editCourrier.addSenderRefRecommended' | translate }}</div>
            }
            @if (checkMatrice?.refExpediteur?.obligatoire === true) {
              <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
            }
          </div>
        </div>
      }
      <div class="d-flex justify-content-between row">
        <div class="form-group col-3 p-fluid mb-2">
          @if (typeEntrantSortant !== 'S') {
            <h4 class="custom-h4-title" id="titleDateEntree">
              {{ 'entryDate' | translate }}
              @if (!configuration?.mails?.hideConfirmNoDateEntree) {
                <span> *</span>
              }
            </h4>
          }
          @if (typeEntrantSortant === 'S') {
            <h4 class="custom-h4-title" id="titleDateSortie">
              {{ 'exitDate' | translate }}
              @if (!configuration?.mails?.hideConfirmNoDateEntree) {
                <span> *</span>
              }
            </h4>
          }
          @if (locale4Calendar) {
            <p-calendar
              [firstDayOfWeek]="1"
              appendTo="body"
              formControlName="dateEntree"
              [showIcon]="true"
              [iconDisplay]="'input'"
              dateFormat="dd/mm/yy"
              [disabled]="configuration && configuration?.mails?.dateEntreeBloquee">
            </p-calendar>
          }
          @if (f.dateEntree.errors && f.dateEntree.errors.required) {
            <div class="input-error">
              La date
              @if (typeEntrantSortant === 'E') {
                <span> d'entrée </span>
              }
              @if (typeEntrantSortant === 'S' || typeEntrantSortant === 'I') {
                <span> de sortie </span>
              }
              est requise
            </div>
          }
        </div>
        @if (checkMatrice?.dateDocument?.invisible === false) {
          <div class="form-group col-3 p-fluid">
            <h4 class="custom-h4-title">
              {{ 'editCourrier.documentDate' | translate }}
              {{ checkMatrice?.dateDocument?.obligatoire || !configuration?.mails?.hideConfirmNoDateDoc ? '*' : '' }}
            </h4>
            @if (locale4Calendar) {
              <p-calendar
                [firstDayOfWeek]="1"
                appendTo="body"
                formControlName="dateDocument"
                [showIcon]="true"
                [iconDisplay]="'input'"
                dateFormat="dd/mm/yy"
                [disabled]="checkMatrice?.dateDocument?.lectureSeule">
              </p-calendar>
            }
            @if (checkMatrice?.dateDocument?.warning === true && checkMatrice?.dateDocument?.obligatoire === false) {
              <div class="input-warning">{{ 'editCourrier.addDocumentDateRecommended' | translate }}</div>
            }
            @if (checkMatrice?.dateDocument?.obligatoire || !configuration?.mails?.hideConfirmNoDateDoc) {
              <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
            }
          </div>
        }
        @if (checkMatrice?.dateEcheance?.invisible === false) {
          <div class="form-group col-3 p-fluid">
            <h4 class="custom-h4-title">{{ 'editCourrier.dueDate' | translate }} {{ checkMatrice?.dateEcheance?.obligatoire ? '*' : '' }}</h4>
            @if (locale4Calendar) {
              <p-calendar
                [firstDayOfWeek]="1"
                appendTo="body"
                formControlName="dateEcheance"
                [showIcon]="true"
                [iconDisplay]="'input'"
                dateFormat="dd/mm/yy"
                (onClose)="checkEcheanceDate()"
                [disabled]="checkMatrice?.dateEcheance?.lectureSeule">
              </p-calendar>
            }
            @if (checkMatrice?.dateEcheance?.warning === true && checkMatrice?.dateEcheance?.obligatoire === false) {
              <div class="input-warning">{{ 'editCourrier.addDueDateRecommended' | translate }}</div>
            }
            @if (checkMatrice?.dateEcheance?.obligatoire === true) {
              <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
            }
          </div>
        }
        <div class="form-group col-3 p-fluid">
          <h4 class="custom-h4-title">{{ 'editCourrier.postalDate' | translate }}</h4>
          @if (locale4Calendar) {
            <i-input [type]="'calendar'" [iInput]="{ options: { dateFormat: 'dd/mm/yy' } }" [control]="form.get('datePostale')"> </i-input>
          }
        </div>
      </div>
      <div class="form-group mb-2">
        <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
          <div>{{ 'object' | translate }} {{ checkMatrice?.objet?.obligatoire ? '*' : '' }}</div>
          @if (!f.objet.value || f.objet.value === '') {
            <span (click)="openObjectBibli()">
              <svg
                style="cursor: pointer"
                width="15px"
                height="15px"
                viewBox="0 0 15 15"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Medium-Copy-19" transform="translate(-449.000000, -315.000000)" fill="#60CDFF" fill-rule="nonzero">
                    <g id="noun-library-3187847" transform="translate(449.000000, 315.000000)">
                      <path
                        d="M3.5,2 L0.5,2 C0.367411429,2 0.240177143,2.05268 0.146428571,2.14642857 C0.05268,2.24017714 0,2.36741143 0,2.5 L0,14.5 C0,14.6325886 0.05268,14.7598229 0.146428571,14.8535714 C0.240177143,14.94732 0.367411429,15 0.5,15 L3.5,15 C3.63258857,15 3.75982286,14.94732 3.85357143,14.8535714 C3.94732,14.7598229 4,14.6325886 4,14.5 L4,2.5 C4,2.36741143 3.94732,2.24017714 3.85357143,2.14642857 C3.75982286,2.05268 3.63258857,2 3.5,2 Z M2.50000714,13.5 L1.50000714,13.5 C1.32131714,13.5 1.15625714,13.4046886 1.06697143,13.25 C0.977685714,13.0953114 0.977685714,12.9046857 1.06697143,12.75 C1.15625714,12.5953143 1.32132286,12.5 1.50000714,12.5 L2.50000714,12.5 C2.67868286,12.5 2.84374286,12.5953114 2.93302857,12.75 C3.02231429,12.9046886 3.02231429,13.0953143 2.93302857,13.25 C2.84374286,13.4046857 2.67867714,13.5 2.50000714,13.5 Z M2.50000714,12 L1.50000714,12 C1.32131714,12 1.15625714,11.9046886 1.06697143,11.75 C0.977685714,11.5953114 0.977685714,11.4046857 1.06697143,11.25 C1.15625714,11.0953143 1.32132286,11 1.50000714,11 L2.50000714,11 C2.67868286,11 2.84374286,11.0953114 2.93302857,11.25 C3.02231429,11.4046886 3.02231429,11.5953143 2.93302857,11.75 C2.84374286,11.9046857 2.67867714,12 2.50000714,12 Z"
                        id="Shape"></path>
                      <path
                        d="M14.9865373,13.5700086 L12.3097279,1.90000857 C12.280121,1.77054571 12.2020244,1.65860286 12.0929286,1.58918 C11.983723,1.51976 11.8525285,1.49844286 11.728205,1.53002857 L8.84468856,2.24497143 L8.84468856,0.5 C8.84468856,0.367411429 8.79405401,0.240177143 8.7039455,0.146428571 C8.61383698,0.05268 8.49154293,0 8.36410249,0 L5.48058607,0 C5.35314563,0 5.23085158,0.05268 5.14074306,0.146428571 C5.05063455,0.240177143 5,0.367411429 5,0.5 L5,14.5 C5,14.6325886 5.05063455,14.7598229 5.14074306,14.8535714 C5.23085158,14.94732 5.35314563,15 5.48058607,15 L8.36410249,15 C8.49154293,15 8.61383698,14.94732 8.7039455,14.8535714 C8.79405401,14.7598229 8.84468856,14.6325886 8.84468856,14.5 L8.84468856,4.36485714 L11.1706977,14.5 C11.1961215,14.6118314 11.2576975,14.7112714 11.3452328,14.7813629 C11.4327681,14.8514543 11.5409,14.88806 11.6512975,14.8850457 L11.7617883,14.8850457 L14.6453048,14.1701029 L14.645412,14.1699913 C14.7660941,14.1359513 14.869291,14.0541427 14.9330222,13.9420884 C14.9967424,13.8300341 15.0159439,13.6965513 14.9865512,13.5700027 L14.9865373,13.5700086 Z M6.92230309,2.00000857 C7.04974353,2.00000857 7.17203758,2.05268857 7.26214609,2.14643714 C7.35225461,2.24018571 7.40288916,2.36742 7.40288916,2.50000857 C7.40288916,2.63259714 7.35225461,2.75983143 7.26214609,2.85358 C7.17203758,2.94732857 7.04974353,3.00000857 6.92230309,3.00000857 C6.79486265,3.00000857 6.6725686,2.94732857 6.58246008,2.85358 C6.49235157,2.75983143 6.44171702,2.63259714 6.44171702,2.50000857 C6.44171702,2.36742 6.49235157,2.24018571 6.58246008,2.14643714 C6.6725686,2.05268857 6.79486265,2.00000857 6.92230309,2.00000857 Z M7.40288916,13.5000086 L6.44171702,13.5000086 C6.26997203,13.5000086 6.11132096,13.4046971 6.02550202,13.2500086 C5.93968308,13.09532 5.93968308,12.9046943 6.02550202,12.7500086 C6.11132096,12.5953229 6.26997753,12.5000086 6.44171702,12.5000086 L7.40288916,12.5000086 C7.57463414,12.5000086 7.73328522,12.59532 7.81910416,12.7500086 C7.9049231,12.9046971 7.9049231,13.0953229 7.81910416,13.2500086 C7.73328522,13.4046943 7.57462865,13.5000086 7.40288916,13.5000086 Z M7.40288916,12.0000086 L6.44171702,12.0000086 C6.26997203,12.0000086 6.11132096,11.9046971 6.02550202,11.7500086 C5.93968308,11.59532 5.93968308,11.4046943 6.02550202,11.2500086 C6.11132096,11.0953229 6.26997753,11.0000086 6.44171702,11.0000086 L7.40288916,11.0000086 C7.57463414,11.0000086 7.73328522,11.09532 7.81910416,11.2500086 C7.9049231,11.4046971 7.9049231,11.5953229 7.81910416,11.7500086 C7.73328522,11.9046943 7.57462865,12.0000086 7.40288916,12.0000086 Z M13.3333213,13.0000086 L12.3961784,13.2300314 L12.2856876,13.2300314 C12.1139426,13.2505671 11.9447735,13.1742286 11.8417908,13.0298086 C11.7389152,12.8853886 11.7177831,12.6947514 11.7865454,12.5298086 C11.8553076,12.3648543 12.0034517,12.2505686 12.1750786,12.2300371 L13.1122215,12.0000143 C13.2839664,11.9589429 13.4636535,12.0163089 13.5836901,12.15046 C13.7037268,12.2846111 13.7458866,12.4751171 13.6942881,12.65046 C13.6425825,12.8256829 13.505058,12.9589457 13.3332993,13.0000029 L13.3333213,13.0000086 Z"
                        id="Shape"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <span class="bibliothequeObjet__blue ms-1">{{ 'editCourrier.objectLibrary' | translate }} </span>
            </span>
          }
          @if (rightUser?.menu?.mails && f.objet.value) {
            <span (click)="openObjectCreate()">
              <svg
                style="cursor: pointer"
                width="15px"
                height="15px"
                viewBox="0 0 15 15"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Medium-Copy-19" transform="translate(-449.000000, -315.000000)" fill="#3BDE86" fill-rule="nonzero">
                    <g id="noun-library-3187847" transform="translate(449.000000, 315.000000)">
                      <path
                        d="M3.5,2 L0.5,2 C0.367411429,2 0.240177143,2.05268 0.146428571,2.14642857 C0.05268,2.24017714 0,2.36741143 0,2.5 L0,14.5 C0,14.6325886 0.05268,14.7598229 0.146428571,14.8535714 C0.240177143,14.94732 0.367411429,15 0.5,15 L3.5,15 C3.63258857,15 3.75982286,14.94732 3.85357143,14.8535714 C3.94732,14.7598229 4,14.6325886 4,14.5 L4,2.5 C4,2.36741143 3.94732,2.24017714 3.85357143,2.14642857 C3.75982286,2.05268 3.63258857,2 3.5,2 Z M2.50000714,13.5 L1.50000714,13.5 C1.32131714,13.5 1.15625714,13.4046886 1.06697143,13.25 C0.977685714,13.0953114 0.977685714,12.9046857 1.06697143,12.75 C1.15625714,12.5953143 1.32132286,12.5 1.50000714,12.5 L2.50000714,12.5 C2.67868286,12.5 2.84374286,12.5953114 2.93302857,12.75 C3.02231429,12.9046886 3.02231429,13.0953143 2.93302857,13.25 C2.84374286,13.4046857 2.67867714,13.5 2.50000714,13.5 Z M2.50000714,12 L1.50000714,12 C1.32131714,12 1.15625714,11.9046886 1.06697143,11.75 C0.977685714,11.5953114 0.977685714,11.4046857 1.06697143,11.25 C1.15625714,11.0953143 1.32132286,11 1.50000714,11 L2.50000714,11 C2.67868286,11 2.84374286,11.0953114 2.93302857,11.25 C3.02231429,11.4046886 3.02231429,11.5953143 2.93302857,11.75 C2.84374286,11.9046857 2.67867714,12 2.50000714,12 Z"
                        id="Shape"></path>
                      <path
                        d="M14.9865373,13.5700086 L12.3097279,1.90000857 C12.280121,1.77054571 12.2020244,1.65860286 12.0929286,1.58918 C11.983723,1.51976 11.8525285,1.49844286 11.728205,1.53002857 L8.84468856,2.24497143 L8.84468856,0.5 C8.84468856,0.367411429 8.79405401,0.240177143 8.7039455,0.146428571 C8.61383698,0.05268 8.49154293,0 8.36410249,0 L5.48058607,0 C5.35314563,0 5.23085158,0.05268 5.14074306,0.146428571 C5.05063455,0.240177143 5,0.367411429 5,0.5 L5,14.5 C5,14.6325886 5.05063455,14.7598229 5.14074306,14.8535714 C5.23085158,14.94732 5.35314563,15 5.48058607,15 L8.36410249,15 C8.49154293,15 8.61383698,14.94732 8.7039455,14.8535714 C8.79405401,14.7598229 8.84468856,14.6325886 8.84468856,14.5 L8.84468856,4.36485714 L11.1706977,14.5 C11.1961215,14.6118314 11.2576975,14.7112714 11.3452328,14.7813629 C11.4327681,14.8514543 11.5409,14.88806 11.6512975,14.8850457 L11.7617883,14.8850457 L14.6453048,14.1701029 L14.645412,14.1699913 C14.7660941,14.1359513 14.869291,14.0541427 14.9330222,13.9420884 C14.9967424,13.8300341 15.0159439,13.6965513 14.9865512,13.5700027 L14.9865373,13.5700086 Z M6.92230309,2.00000857 C7.04974353,2.00000857 7.17203758,2.05268857 7.26214609,2.14643714 C7.35225461,2.24018571 7.40288916,2.36742 7.40288916,2.50000857 C7.40288916,2.63259714 7.35225461,2.75983143 7.26214609,2.85358 C7.17203758,2.94732857 7.04974353,3.00000857 6.92230309,3.00000857 C6.79486265,3.00000857 6.6725686,2.94732857 6.58246008,2.85358 C6.49235157,2.75983143 6.44171702,2.63259714 6.44171702,2.50000857 C6.44171702,2.36742 6.49235157,2.24018571 6.58246008,2.14643714 C6.6725686,2.05268857 6.79486265,2.00000857 6.92230309,2.00000857 Z M7.40288916,13.5000086 L6.44171702,13.5000086 C6.26997203,13.5000086 6.11132096,13.4046971 6.02550202,13.2500086 C5.93968308,13.09532 5.93968308,12.9046943 6.02550202,12.7500086 C6.11132096,12.5953229 6.26997753,12.5000086 6.44171702,12.5000086 L7.40288916,12.5000086 C7.57463414,12.5000086 7.73328522,12.59532 7.81910416,12.7500086 C7.9049231,12.9046971 7.9049231,13.0953229 7.81910416,13.2500086 C7.73328522,13.4046943 7.57462865,13.5000086 7.40288916,13.5000086 Z M7.40288916,12.0000086 L6.44171702,12.0000086 C6.26997203,12.0000086 6.11132096,11.9046971 6.02550202,11.7500086 C5.93968308,11.59532 5.93968308,11.4046943 6.02550202,11.2500086 C6.11132096,11.0953229 6.26997753,11.0000086 6.44171702,11.0000086 L7.40288916,11.0000086 C7.57463414,11.0000086 7.73328522,11.09532 7.81910416,11.2500086 C7.9049231,11.4046971 7.9049231,11.5953229 7.81910416,11.7500086 C7.73328522,11.9046943 7.57462865,12.0000086 7.40288916,12.0000086 Z M13.3333213,13.0000086 L12.3961784,13.2300314 L12.2856876,13.2300314 C12.1139426,13.2505671 11.9447735,13.1742286 11.8417908,13.0298086 C11.7389152,12.8853886 11.7177831,12.6947514 11.7865454,12.5298086 C11.8553076,12.3648543 12.0034517,12.2505686 12.1750786,12.2300371 L13.1122215,12.0000143 C13.2839664,11.9589429 13.4636535,12.0163089 13.5836901,12.15046 C13.7037268,12.2846111 13.7458866,12.4751171 13.6942881,12.65046 C13.6425825,12.8256829 13.505058,12.9589457 13.3332993,13.0000029 L13.3333213,13.0000086 Z"
                        id="Shape"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <span class="bibliothequeObjet__green ms-1">{{ 'editCourrier.addToObjectLibrary' | translate }} </span>
            </span>
          }
        </h4>
        <textarea class="w-100" pInputTextarea [rows]="3" formControlName="objet" data-test="objet" name="objet" id="createCourrierObjet"></textarea>
        @if (f.objet.dirty && f.objet.invalid && f.objet?.errors['maxlength']) {
          <div class="input-error">{{ 'editCourrier.objectLengthExceedsLimit' | translate }}</div>
        }
        @if (checkMatrice?.objet?.warning === true && checkMatrice?.objet?.obligatoire === false) {
          <div class="input-warning">{{ 'editCourrier.addObjectRecommended' | translate }}</div>
        }
        @if (checkMatrice?.objet?.obligatoire === true) {
          <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
        }
      </div>
      @if (form.value.typeEntrantSortant === 'E') {
        <div class="mb-3">
          <i-tabs class="box" [items]="actionTabs" (tabChange)="onChangeTabsExpediteurs($event)"></i-tabs>
        </div>
      }
      <div class="row mb-2">
        @if (expediteurTabsActive === 'existing') {
          <div class="form-group col-12">
            <div class="row">
              <div class="col-12 mb-3 align-items-center">
                <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                  <div>
                    {{ 'sender' | translate }}
                    {{ checkMatrice?.expediteur?.obligatoire || typeEntrantSortant === 'S' || typeEntrantSortant === 'I' ? '*' : '' }}
                    @if (typeEntrantSortant === 'E') {
                      <i
                        class="bi bi-info-circle ms-2"
                        pTooltip="Veuillez entrer 3 lettres minimum afin d'effectuer une recherche"
                        tooltipPosition="top"></i>
                    }
                  </div>
                  <div class="cta__right">
                    <i class="bi bi-search cursor--pointer" (click)="openModalSearchSender()"></i>
                  </div>
                </h4>
                <div class="d-flex align-items-center p-fluid">
                  @if (typeEntrantSortant === 'E') {
                    <p-toggleButton
                      styleClass="custom-toggle-button_advancedSearch"
                      [onLabel]="'mainNav.contacts' | translate"
                      [offLabel]="'mainNav.users' | translate"
                      [onIcon]="'bi bi-person-vcard'"
                      [offIcon]="'bi bi-person'"
                      [(ngModel)]="recipientSourceBoolean"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="onChangeToggleButtonUsersContacts($event)"></p-toggleButton>
                  }
                  @if (typeEntrantSortant === 'E') {
                    <p-autoComplete
                      #autocomplete
                      id="expediteursAutocomplete"
                      type="search"
                      class="w-100"
                      styleClass="custom-multi-select_advancedSearch"
                      field="label"
                      dataKey="value"
                      [formControl]="formControlNameForExpediteur"
                      [showEmptyMessage]="true"
                      [placeholder]="'pleaseSelectASender' | translate"
                      [suggestions]="filteredExpediteurs | sort: 'label' : 'ASC'"
                      (completeMethod)="searchSenderAutoComplete($event)"
                      (onSelect)="onSelectSender($event)">
                      <ng-template let-selectedItem pTemplate="selectedItem"> {{ selectedItem.label }} </ng-template>
                      <ng-template let-contact pTemplate="item">
                        @if (form.value.recipientSource === 'iAdmin') {
                          <div>
                            <div class="expediteursDropdown__label">{{ contact?.label }}</div>
                          </div>
                        }
                        @if (form.value.recipientSource === 'iCourrier') {
                          <div
                            class="d-flex align-items-center justify-content-between"
                            pTooltip="{{ contact?.label + '<br>' }} {{
                              contact?.nameTypeContact ? 'Type: ' + contact.nameTypeContact + '<br>' : null
                            }} {{ contact?.adresse ? 'Adresse: ' + contact?.adresse : 'Adresse: /' + '<br>' }}"
                            tooltipPosition="bottom">
                            <div class="expediteursDropdown__label">{{ contact?.label }}</div>
                            <div class="d-flex align-items-center" style="width: fit-content">
                              <i class="bi bi-info-circle me-2" (click)="showMoreInfoContact(contact); display = true"></i>
                              <i class="bi bi-pencil-fill iconSmaller ms-1" (click)="openUpdateUser(contact)"></i>
                            </div>
                          </div>
                        }
                      </ng-template>
                      <ng-template let-item pTemplate="empty">
                        <div class="d-flex align-items-center justify-content-between">{{ 'noContactFound' | translate }}</div>
                      </ng-template>
                    </p-autoComplete>
                  }
                  @if (contacts.length > 0 && (typeEntrantSortant === 'S' || typeEntrantSortant === 'I')) {
                    <p-dropdown
                      id="expediteursDropdown"
                      [showClear]="true"
                      [options]="contacts | removeEmptyLabel: 'label' | sort: 'label' : 'ASC'"
                      [placeholder]="'pleaseSelectASender' | translate"
                      [filter]="true"
                      class="w-100"
                      styleClass="custom-multi-select_advancedSearch dropdown-inforius"
                      [formControl]="formControlNameForExpediteur"
                      autocomplete="new-password"
                      name="expediteurId"
                      [emptyFilterMessage]="'noResultFound' | translate"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="31">
                      <ng-template let-item pTemplate="selectedItem"> {{ item?.label }} </ng-template>
                      <ng-template let-contact pTemplate="item">
                        <div
                          class="d-flex align-items-center justify-content-between"
                          pTooltip="{{ contact?.label + '<br>' }} {{
                            contact?.nameTypeContact ? 'Type: ' + contact.nameTypeContact + '<br>' : null
                          }} {{ contact?.adresse ? 'Adresse: ' + contact?.adresse : 'Adresse: /' + '<br>' }}"
                          tooltipPosition="bottom">
                          <div class="expediteursDropdown__label">{{ contact?.label }}</div>
                          <div class="d-flex align-items-center" style="width: fit-content">
                            <i class="bi bi-info-circle me-2" (click)="showMoreInfoContact(contact); display = true"></i>
                            <i class="bi bi-pencil-fill iconSmaller ms-1" (click)="openUpdateUser(contact)"></i>
                          </div>
                        </div>
                      </ng-template>
                    </p-dropdown>
                  }
                  @if (checkMatrice?.expediteur?.obligatoire && !f.expediteurId.value) {
                    <div class="input-error" id="noExpediteurText">{{ 'editCourrier.senderRequired' | translate }}</div>
                  }
                  @if (checkMatrice?.expediteur?.warning === true && !f.expediteurId.value) {
                    <div class="input-warning" id="recommendedExpediteur">{{ 'recommendedToAddSender' | translate }}</div>
                  }
                  @if (
                    !serviceProprietaireId &&
                    !form.value.serviceProprietaireId &&
                    (form.value.typeEntrantSortant === 'S' || form.value.typeEntrantSortant === 'I')
                  ) {
                    <div class="input-warning">{{ 'pleaseSelectAServiceForExpeditors' | translate }}</div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (expediteurTabsActive === 'new') {
          <div class="form-group col-12 mt-2">
            <app-contact-new-simple
              [savingNewExpFromCourrier]="isSavingNewExpediteur.asObservable()"
              (canSaveContact)="receiveCanSaveContact($event)"
              (contactIsSaved)="contactFormToBeSaved($event)"></app-contact-new-simple>
          </div>
        }
        @if (expediteurTabsActive === 'free') {
          <div class="form-group col-12 mt-2">
            <textarea
              rows="5"
              cols="30"
              placeholder="Encoder l'expéditeur libre"
              formControlName="expediteurLibre"
              class="super-compos-input-text form-control w-100"
              [attr.data-test]="'expediteur-libre'"
              pInputTextarea></textarea>
            @if (checkMatrice?.expediteur?.obligatoire && !f.expediteurLibre.value) {
              <div class="input-error">{{ 'freeSenderRequired' | translate }}</div>
            }
            @if (checkMatrice?.expediteur?.warning === true && !f.expediteurLibre.value) {
              <div class="input-warning" id="recommendedExpediteur">{{ 'recommendedToAddSender' | translate }}</div>
            }
          </div>
        }
        @if (form.value.typeEntrantSortant === 'E') {
          <div class="d-flex w-100 justify-content-center mb-3" style="border-bottom: 1px solid rgba(151, 151, 151, 0.5)"></div>
        }
      </div>
      @if (configuration?.mails?.hideClassementDossiers === false) {
        <div class="row">
          @if (codesclassementsLV.length > 0 && checkMatrice?.codeClassement?.invisible === false) {
            <div class="form-group col-12 mb-2">
              <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                {{ 'classificationCode' | translate }} {{ checkMatrice?.codeClassement?.obligatoire ? '*' : '' }}
                <div class="cta__right">
                  @if (rightUser?.menu?.codesClassement) {
                    <i class="bi bi-plus-circle-fill greenIcon cursor--pointer me-2" (click)="openAddClassement()"></i>
                  }
                  <i
                    class="bi bi-search cursor--pointer"
                    [ngClass]="{ 'bi-search__grayIcon': !form.value.serviceProprietaireId }"
                    [pTooltip]="getTooltipForClassificationSearch()"
                    (click)="openModalClassement()"></i>
                </div>
              </h4>
              <p-dropdown
                [showClear]="true"
                [options]="codesclassementsLV | sort: 'label' : 'ASC'"
                [placeholder]="'pleaseSelectACodeClassification' | translate"
                [filter]="true"
                styleClass="w-100 dropdown-inforius"
                formControlName="classementId"
                appendTo="body"
                autocomplete="new-password"
                [emptyFilterMessage]="'noResultFound' | translate"
                id="classementId"
                (onShow)="isDropdownToggled = true; moveAutocomplete()"
                (onHide)="isDropdownToggled = false; onHideClassementMethod()"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31"
                [attr.data-test]="'classement'"
                (onChange)="onChangeClassement()">
                <ng-template let-selectedItem pTemplate="selectedItem"> {{ selectedItem?.label }} </ng-template>
                <ng-template let-item pTemplate="item">
                  <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                    <div [pTooltip]="item.label">{{ item?.label }}</div>
                  </div>
                </ng-template>
              </p-dropdown>
              @if (checkMatrice?.codeClassement?.warning === true && checkMatrice?.codeClassement?.obligatoire === false) {
                <div class="input-warning">{{ 'editCourrier.addClassificationCodeRecommended' | translate }}</div>
              }
              @if (checkMatrice?.codeClassement?.obligatoire === true) {
                <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
              }
              @if (codesclassementsLV.length === 0) {
                <div class="form-group col-4 input-warning">{{ 'editCourrier.selectServiceToViewClassifications' | translate }}</div>
              }
            </div>
          }
          <!-- JIRA 2806 : Vu avec MPE => Afficher au moins le titre ssi l'item précédent existe -->
          @if (form.value.classementId && form.value.serviceProprietaireId) {
            <div class="form-group col-12 mb-2">
              <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                <div>
                  {{ 'mailInfo.binder' | translate }}
                  <p-checkbox
                    class="ms-1"
                    binary="true"
                    [(ngModel)]="classeurCheckArchived"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="displayArchived('classeur', $event)"></p-checkbox>
                  <span class="displayArchivedClassementLabel">{{ 'editCourrier.showArchived' | translate }}</span>
                </div>
                @if (rightUser?.menu.classementDossiers === true || rightUser.menu.classementDossiersPartiel === true) {
                  <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openAddFarde()"></i>
                }
              </h4>
              @if (classeursLV.length > 0) {
                <p-dropdown
                  styleClass="w-100 dropdown-inforius"
                  formControlName="classeurId"
                  appendTo="body"
                  autocomplete="new-password"
                  id="classeurId"
                  [showClear]="true"
                  [options]="classeursLV | sort: 'label' : 'ASC'"
                  [placeholder]="'pleaseSelectAFolder' | translate"
                  [filter]="true"
                  [emptyFilterMessage]="'editCourrier.noResultsFoundFilingCabinet' | translate"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="31"
                  (onShow)="moveAutocomplete()"
                  [attr.data-test]="'classeur'"
                  (onChange)="getChemises($event.value)">
                  <ng-template let-item pTemplate="selectedItem">
                    @if (item?.partage) {
                      <i class="bi bi-people-fill"></i>
                    }
                    {{ item?.label }}
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                      <div [pTooltip]="item.label">
                        @if (item?.partage) {
                          <i class="bi bi-people-fill me-1"></i>
                        }
                        {{ item?.label }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              }
              @if (classeursLV.length === 0) {
                <div class="form-group col-4 input-warning">{{ 'editCourrier.noFilingCabinetsAvailable' | translate }}</div>
              }
            </div>
          }
          <!-- JIRA 2806 : Vu avec MPE => Afficher au moins le titre ssi l'item précédent existe -->
          @if (form.value.classeurId && form.value.serviceProprietaireId) {
            <div class="form-group col-12 mb-2">
              <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                <div>
                  {{ 'editCourrier.folder' | translate }} *
                  <!-- on rend obligatoire car si une farde est choisie ALORS la chemise sera obligatoire -->
                  <p-checkbox
                    class="ms-1"
                    binary="true"
                    [(ngModel)]="chemiseCheckArchived"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="displayArchived('chemise', $event)"></p-checkbox>
                  <span class="displayArchivedClassementLabel">{{ 'editCourrier.showArchived' | translate }}</span>
                </div>
                @if (rightUser?.menu.classementDossiers === true || rightUser.menu.classementDossiersPartiel === true) {
                  <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openAddChemise()"></i>
                }
              </h4>
              @if (chemisesLV.length > 0) {
                <p-dropdown
                  styleClass="w-100 dropdown-inforius"
                  formControlName="chemiseId"
                  appendTo="body"
                  autocomplete="new-password"
                  id="chemiseId"
                  [showClear]="true"
                  [options]="chemisesLV | sort: 'label' : 'ASC'"
                  [placeholder]="'editCourrier.selectFolder' | translate"
                  [filter]="true"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="31"
                  [emptyFilterMessage]="'editCourrier.noResultsFoundFilingCabinet' | translate"
                  (onShow)="moveAutocomplete()"
                  [attr.data-test]="'chemise'">
                  <ng-template let-item pTemplate="selectedItem">
                    @if (item?.partage) {
                      <i class="bi bi-people-fill"></i>
                    }
                    {{ item?.label }}
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                      <div [pTooltip]="item.label">
                        @if (item?.partage) {
                          <i class="bi bi-people-fill me-1"></i>
                        }
                        {{ item?.label }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              }
              @if (chemisesLV.length === 0) {
                <div class="form-group col-4 input-warning">{{ 'editCourrier.noFoldersAvailable' | translate }}</div>
              }
            </div>
          }
        </div>
      }
      <div class="row">
        <div class="complementary-data-container col-12 mb-2">
          @if (checkMatrice?.nature?.invisible === false) {
            <div class="form-group col-12 mb-2">
              <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
                {{ 'editCourrier.nature' | translate }} {{ checkMatrice?.nature?.obligatoire || configuration?.mails?.obligationNature ? '*' : '' }}
                @if (rightUser?.menu?.mails) {
                  <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openNatureCreate('typeNature')"></i>
                }
              </h4>
              <p-dropdown
                [showClear]="true"
                [options]="natureListLV"
                [placeholder]="'editCourrier.selectNature' | translate"
                [filter]="true"
                styleClass="w-100 dropdown-inforius"
                formControlName="natureId"
                autocomplete="new-password"
                [emptyFilterMessage]="'editCourrier.noResultsFoundFilingCabinet' | translate"
                id="natureId"
                (onChange)="changeNature($event.value); checkForComplementaryData($event.value)"
                (onShow)="moveAutocomplete()"
                [readonly]="checkMatrice?.nature?.lectureSeule"
                [attr.data-test]="'nature'">
              </p-dropdown>
              @if (checkMatrice?.nature?.warning === true && checkMatrice?.nature?.obligatoire === false) {
                <div class="input-warning">{{ 'editCourrier.addNatureRecommended' | translate }}</div>
              }
              @if (checkMatrice?.nature?.obligatoire === true) {
                <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
              }
            </div>
          }
          @if (dataToPrepareForForm?.controls?.length > 0 && !loadingComplementaryDatas) {
            <div class="complementdata col-md-12 mb-2">
              <app-complement-data-form
                [mode]="'create'"
                [natureWithComplementaryDatas]="natureWithComplementaryDatas"
                [formData]="dataToPrepareForForm"
                (formValue)="receive_complementData($event)"></app-complement-data-form>
            </div>
          }
        </div>
        @if (checkMatrice?.source?.invisible === false) {
          <div class="form-group col-6 mb-2">
            <h4 class="custom-h4-title d-flex align-items-center justify-content-between">
              {{ 'source' | translate }} {{ checkMatrice?.source?.obligatoire || configuration?.mails?.obligationSource ? '*' : '' }}
              @if (rightUser?.menu?.mails) {
                <i class="bi bi-plus-circle-fill greenIcon cursor--pointer ms-2" (click)="openNatureCreate('typeSource')"></i>
              }
            </h4>
            <div class="row">
              <div class="col-md-12 mb-2" [ngClass]="{ 'col-md-6': showRefRecommanded }">
                <p-dropdown
                  [showClear]="true"
                  [options]="sourceListLV | sort: 'label' : 'ASC'"
                  autocomplete="new-password"
                  [placeholder]="'pleaseSelectASource' | translate"
                  [filter]="true"
                  styleClass="w-100 dropdown-inforius"
                  (onChange)="showRef($event.value); changeSource($event.value)"
                  #Dropdown
                  formControlName="sourceId"
                  [emptyFilterMessage]="'noResultFound' | translate"
                  id="sourceId"
                  (onShow)="moveAutocomplete()"
                  [readonly]="checkMatrice?.source?.lectureSeule"
                  [attr.data-test]="'source'">
                </p-dropdown>
                @if (checkMatrice?.source?.warning === true && checkMatrice?.source?.obligatoire === false) {
                  <div class="input-warning">{{ 'editCourrier.addSourceRecommended' | translate }}</div>
                }
                @if (checkMatrice?.source?.obligatoire === true) {
                  <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                }
              </div>
              @if (showRefRecommanded && checkMatrice?.refRecommande?.invisible === false) {
                <div class="col-md-6">
                  <label>{{ 'editCourrier.recommendedRef' | translate }} {{ checkMatrice?.refRecommande?.obligatoire ? '*' : '' }}</label>
                  <input
                    formControlName="referenceRecommande"
                    type="text"
                    class="super-compos-input-text form-control w-100"
                    name="referenceRecommande"
                    [readonly]="checkMatrice?.refRecommande?.lectureSeule"
                    [attr.data-test]="'ref-recommande'" />
                  @if (checkMatrice?.refRecommande?.warning === true && checkMatrice?.refRecommande?.obligatoire === false) {
                    <div class="input-warning">{{ 'editCourrier.addRecommendedRefRecommended' | translate }}</div>
                  }
                  @if (checkMatrice?.refRecommande?.obligatoire === true) {
                    <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="row">
        @if (!selectedUserService || (selectedUserService && !selectedUserService.cacherStatutsMultiples)) {
          <div class="form-group col-6 mb-2">
            <h4 class="custom-h4-title">{{ 'status.title' | translate }}</h4>
            <p-dropdown
              [showClear]="true"
              [options]="statutListLV"
              placeholder="pleaseSelectAStatus"
              [placeholder]="'pleaseSelectAStatus' | translate"
              [filter]="true"
              styleClass="w-100 dropdown-inforius"
              formControlName="statutId"
              autocomplete="new-password"
              [emptyFilterMessage]="'noResultFound' | translate"
              id="statutId"
              [attr.data-test]="'statut'">
            </p-dropdown>
          </div>
        }
        @if (checkMatrice?.boiteArchive?.invisible === false) {
          <div class="form-group col-6">
            <h4 class="custom-h4-title">{{ 'editCourrier.archiveBox' | translate }} {{ checkMatrice?.boiteArchive?.obligatoire ? '*' : '' }}</h4>
            <input
              type="text"
              pInputText
              class="super-compos-input-text form-control w-100"
              formControlName="boiteArchive"
              [readonly]="checkMatrice?.boiteArchive?.lectureSeule"
              [attr.data-test]="'boite-archive'" />
            @if (checkMatrice?.boiteArchive?.warning === true && checkMatrice?.boiteArchive?.obligatoire === false) {
              <div class="input-warning">{{ 'editCourrier.addArchiveBoxRecommended' | translate }}</div>
            }
            @if (checkMatrice?.boiteArchive?.obligatoire === true) {
              <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
            }
          </div>
        }
      </div>
      @if (checkMatrice?.remarques?.invisible === false) {
        <div class="row">
          <div class="form-group col-12 mb-2">
            <h4 class="custom-h4-title">{{ 'remarks' | translate }} {{ checkMatrice?.remarques?.obligatoire ? '*' : '' }}</h4>
            <textarea
              class="w-100"
              pInputTextarea
              [rows]="3"
              formControlName="remarques"
              name="remarques"
              [attr.data-test]="'remarques'"
              [readonly]="checkMatrice?.remarques?.lectureSeule"></textarea>
            @if (checkMatrice?.remarques?.warning === true && checkMatrice?.remarques?.obligatoire === false) {
              <div class="input-warning">{{ 'editCourrier.addRemarksRecommended' | translate }}</div>
            }
            @if (checkMatrice?.remarques?.obligatoire === true) {
              <div class="input-warning">{{ '(mandatoryField)' | translate }}</div>
            }
          </div>
        </div>
      }
    </form>
  </div>
}

<p-confirmDialog
  #cd
  key="courrierForm"
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'continueWithoutRegistration' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'register' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog
  #cdExpediteur
  key="courrierFormExpediteur"
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'goBackOnForm' | translate" (click)="cdExpediteur.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'register' | translate" (click)="cdExpediteur.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog
  #xd
  appendTo="body"
  key="confirmCourrierComplete"
  baseZIndex="1000"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle">
  <p-footer>
    <button
      type="button"
      class="pButtonRed"
      id="cancelConfirm"
      pButton
      icon="pi pi-times"
      [label]="'global.no' | translate"
      (click)="xd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" id="accceptConfirm" [label]="'global.yes' | translate" (click)="xd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog
  key="confirmContact"
  #cc
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  header="Confirmation"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cc.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cc.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-dialog [header]="'complementaryInfos' | translate" [(visible)]="display">
  @if (contactInfoComplementary.length > 0) {
    <i-table
      [paginator]="true"
      class="super-table"
      [columns]="columnsContactInfoComplementary"
      [items]="contactInfoComplementary"
      id="contactInfoComplementary"
      [multiselect]="false">
    </i-table>
  }
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  baseZIndex="1000"
  appendTo="body"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '50vw' }"
  [(visible)]="showCreate">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'createNewTypeNatureSource' | translate }}</h5>
    </div>
  </p-header>
  <form [formGroup]="formNatureSource" class="mt-3 mb-3 row">
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'description' | translate }} *</label>
      <i-input
        [iInput]="{ placeholder: 'description' | translate }"
        [type]="'text'"
        [control]="formNatureSource.get('description')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'sortOrder' | translate }}</label>
      <i-input
        [iInput]="{ placeholder: 'sortOrder' | translate }"
        [type]="'text'"
        [control]="formNatureSource.get('ordreTri')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-12 mb-3">
      <div class="p-field-radiobutton">
        <label class="super-compos-label-input">{{ 'type' | translate }} *</label>
        <p-radioButton name="type" value="typeNature" formControlName="type" inputId="typeNature"></p-radioButton>
        <label class="ms-3" for="typeNature">{{ 'mailNature' | translate }}</label>
      </div>
      <div class="p-field-radiobutton">
        <p-radioButton name="type" value="typeSource" formControlName="type" inputId="typeSource"></p-radioButton>
        <label class="ms-3" for="typeSource">{{ 'mailSource' | translate }}</label>
      </div>
    </div>
    <div class="col-md-12 mb-3">
      <div class="p-field-checkbox">
        <p-checkbox inputId="binary5" binary="true" formControlName="typeMail"></p-checkbox>
        <label class="ms-2 mb-0" for="binary5">{{ 'emailType' | translate }}</label>
      </div>
    </div>
    <div class="col-md-12 mb-3">
      <div class="p-field-checkbox">
        <p-checkbox inputId="binary6" binary="true" formControlName="accuseReceptionAutomatique"></p-checkbox>
        <label class="ms-2 mb-0" for="binary6">{{ 'needsReceiptAcknowledgment' | translate }}</label>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input" for="ref">{{ 'displayRegisteredMailReference' | translate }}</label>
      <p-checkbox name="ref" binary="true" formControlName="afficherReferenceRecommande" (onChange)="changeRef()"></p-checkbox>
      {{ defaultRef }}
    </div>
    @if (defaultRef === 'Oui') {
      <div class="col-md-6 mb-3">
        <label class="super-compos-label-input">{{ 'registeredMailReference' | translate }}</label>
        <i-input
          [iInput]="{ placeholder: 'registeredMailReference' | translate }"
          [type]="'text'"
          [control]="formNatureSource.get('refRecommande')"
          [showError]="false"
          styleClass="d-block w-100"></i-input>
      </div>
    }
    <div class="col-md-12 mb-3">
      <label class="super-compos-label-input"
        >{{ 'accessRights' | translate }}
        <i class="bi bi-info-circle me-2" [pTooltip]="'ifNoCheckNoSecurity' | translate"></i>
      </label>
      <p-multiSelect
        appendTo="body"
        [options]="servicesFusionned | sort: 'label' : 'ASC'"
        [placeholder]="'pleaseSelectOneOrMultipleServices' | translate"
        styleClass="w-100"
        formControlName="serviceIds"
        [virtualScroll]="true"
        virtualScrollItemSize="30">
      </p-multiSelect>
    </div>
  </form>
  <i-button styleClass="bottomButton red mb-3" (click)="showCreate = false" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" (click)="submitNatureSource()" [text]="'confirm' | translate"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  appendTo="body"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [closable]="true"
  [(visible)]="showCreateObject">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'objectTemplateManagement' | translate }}</h5>
    </div>
  </p-header>
  <form [formGroup]="formObject" class="mt-3 mb-3 row">
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'object' | translate }} *</label>
      <textarea class="form-control" type="text" pInputText formControlName="objet" [placeholder]="'object' | translate"></textarea>
    </div>
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'service' | translate }}</label>
      <p-dropdown
        id="servicesDropdownManageObjectTemplate"
        [options]="services"
        [virtualScroll]="true"
        [filter]="true"
        [virtualScrollItemSize]="30"
        [placeholder]="'pleaseSelectAService' | translate"
        formControlName="serviceId"
        autocomplete="new-password"
        appendTo="body">
        <ng-template let-service pTemplate="item">
          <span [pTooltip]="service.label">{{ service.label | maxLength: 50 }}</span>
        </ng-template>
      </p-dropdown>
    </div>
  </form>
  <i-button [text]="'cancel' | translate" styleClass="bottomButton red mb-3" (click)="showCreateObject = false; formObject.reset()"></i-button>
  <i-button [text]="'confirm' | translate" [disabled]="!formObject.valid" styleClass="bottomButton green" (click)="submitObject()"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  appendTo="body"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [closable]="true"
  [(visible)]="openBibli">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'objectsLibrary' | translate }}</h5>
    </div>
  </p-header>
  <div class="mt-3 mb-3 row">
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'filterByService' | translate }}</label>
      <p-dropdown
        styleClass="w-100"
        [options]="servicesFusionned"
        [virtualScroll]="true"
        [filter]="true"
        virtualScrollItemSize="30"
        [placeholder]="'pleaseSelectAService' | translate"
        [showClear]="true"
        (onChange)="filterServiceForObject($event.value)"
        appendTo="body"
        autocomplete="new-password"
        [(ngModel)]="form.value.serviceProprietaireId">
        <ng-template let-service pTemplate="item">
          <span [pTooltip]="service.label">{{ service.label | maxLength: 50 }}</span>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'object' | translate }}</label>
      @if (objectsmodeles.length > 0) {
        <p-dropdown
          styleClass="w-100"
          [options]="objectsmodeles"
          autocomplete="new-password"
          [virtualScroll]="true"
          [filter]="true"
          virtualScrollItemSize="30"
          [placeholder]="'pleaseSelectAnObject' | translate"
          [(ngModel)]="objectModel"
          appendTo="body">
          <ng-template let-objet pTemplate="item">
            <span [pTooltip]="objet.label">{{ objet.label | maxLength: 50 }}</span>
          </ng-template>
        </p-dropdown>
      }
      @if (objectsmodeles.length === 0) {
        <div class="alert alert-primary">{{ 'noObjectTemplateForSelectedService' | translate }}</div>
      }
    </div>
  </div>
  <i-button [text]="'cancel' | translate" styleClass="bottomButton red mb-3" (click)="openBibli = false"></i-button>
  <i-button [text]="'confirm' | translate" [disabled]="!formObject.valid" styleClass="bottomButton green" (click)="confirmObject()"></i-button>
</p-dialog>

<p-dialog styleClass="super-compos-modal-content modal-scss" appendTo="body" [modal]="false" [closable]="true" [(visible)]="showCreateNewClassement">
  <p-header>
    <div class="d-flex align-items-center justify-content-start">
      <h5 class="modal-title personalized-modal-title-iCourrier"></h5>
      {{ 'classificationCreation' | translate }}
    </div>
  </p-header>
  <form [formGroup]="formNewClassement" class="mt-3 row">
    <div class="col-md-12 mb-3">
      <label class="super-compos-label-input">{{ 'active' | translate }}</label>
      <p-inputSwitch formControlName="actif" binary="true"></p-inputSwitch>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'description' | translate }} *</label>
      <i-input
        [iInput]="{ placeholder: 'description' | translate }"
        [type]="'text'"
        [control]="formNewClassement.get('description')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'code' | translate }} *</label>
      <i-input
        [iInput]="{ placeholder: 'code' | translate }"
        [type]="'text'"
        [control]="formNewClassement.get('code')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
  </form>
  <i-button styleClass="bottomButton red mb-3" [text]="'cancel' | translate" (click)="showCreateNewClassement = false"></i-button>
  <i-button
    styleClass="bottomButton green"
    [disabled]="!formNewClassement.valid"
    (click)="submitNewClassement()"
    [text]="'register' | translate"></i-button>
</p-dialog>

@if (displayCreateEditBinderComponent) {
  <p-dialog
    appendTo="body"
    [modal]="false"
    [closable]="false"
    [showHeader]="true"
    [header]="headerForModal"
    [style]="{ width: '50vw' }"
    [(visible)]="displayCreateEditBinderComponent">
    <app-create-edit-binder-modal
      [servicesParentSingleSelection]="showAllServices ? serviceParent : servicesOnlyParent"
      [classementsLV]="codesclassementsLV"
      [servicesFusionned]="servicesFusionned"
      [formDatasToSendBackToCreateBinder]="formDatasToSendBackToCreateBinder"
      [preSelectedService]="form.value.serviceProprietaireId"
      [preSelectedClassificationCode]="form.value.classementId"
      (closeCreateEditBinder)="onCloseCreateEditBinder($event)"></app-create-edit-binder-modal>
  </p-dialog>
}
@if (displayCreateEditPlasticLinerComponent) {
  <p-dialog
    appendTo="body"
    [modal]="false"
    [closable]="false"
    [showHeader]="true"
    [header]="headerForModal"
    [style]="{ width: '50vw' }"
    [(visible)]="displayCreateEditPlasticLinerComponent">
    <app-create-edit-plastic-liner
      [selectedRowData]="selectedRowDataForModal"
      [servicesParentSingleSelection]="showAllServices ? serviceParent : servicesOnlyParent"
      [servicesFusionned]="servicesFusionned"
      [formDatasToSendBackToCreatePlasticLiner]="formDatasToSendBackToCreatePlasticLiner"
      (closeCreateEditPlasticLiner)="onCloseCreateEditPlasticLiner($event)"></app-create-edit-plastic-liner>
  </p-dialog>
}
@if (displaySenderModal) {
  <p-dialog
    appendTo="body"
    [modal]="false"
    [closable]="false"
    [showHeader]="true"
    [header]="headerForModal"
    [style]="{ width: '50vw' }"
    [(visible)]="displaySenderModal">
    <app-search-recipient
      [mode]="typeEntrantSortant === 'E' ? 'autocomplete' : 'table'"
      [contactTypes]="contactTypes"
      [expediteurContactNeededToBeAdded]="expediteurContactNeededToBeAdded"
      [contactOrigin]="form.value.recipientSource"
      [contacts]="typeEntrantSortant === 'E' ? [] : contacts"
      (closeContactSearchModal)="onCloseSenderModal($event)">
    </app-search-recipient>
  </p-dialog>
}
@if (displayModalClassificationSearch) {
  <p-dialog
    appendTo="body"
    [modal]="false"
    [closable]="true"
    [showHeader]="true"
    [header]="headerForModal"
    [style]="{ width: '60vw' }"
    [(visible)]="displayModalClassificationSearch">
    <app-classement-modal
      [courrier]="serviceDataForClassificationSearchModal"
      [advancedMode]="true"
      (closeClassificationSearchModal)="onCloseClassificationSearchModal($event)">
    </app-classement-modal>
  </p-dialog>
}
